import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch, faHome, faFolderPlus, faFileAlt, faCog,
  faSignOutAlt, faPlusSquare, faUser,
  faInbox,faEye,faBell,faCheckCircle,faMoneyBillWave,faHistory,
  faTimes,
  faTimesCircle,
  faBuilding
} from '@fortawesome/free-solid-svg-icons';
import EtatChargesStructure from '../components/EtatChargesStructure';
import { ProjetsPage } from '../components/ProjetsPage';
import EtatFiltrage from '../components/FiltreDepenses';
import FiltreCharges from '../components/FiltreCharges';
import { createProject } from '../services/projectService';
import EtatImmoStructure from '../components/EtatImmoStructure';
import pb from '../api/pocketbase';

function groupEntriesByRubrique(entries) {
  return entries.reduce((acc, entry) => {
    if (!acc[entry.rubrique]) acc[entry.rubrique] = [];
    acc[entry.rubrique].push(entry);
    return acc;
  }, {});
}

function formatNumberWithSeparator(value) {
  if (value === undefined || value === null) return '';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function depensesParProjet(depenses) {
  return depenses.reduce((acc, dep) => {
    const projetNom =
      dep.nomProjet ||
      dep.projectNom ||
      dep.nom ||
      dep.projet?.nom ||
      dep.expand?.projet?.nom ||
      "Projet non spécifié";
    if (!acc[projetNom]) acc[projetNom] = [];
    acc[projetNom].push(dep);
    return acc;
  }, {});
}

function getRubrique(dep) {
  if (dep.rubrique) return dep.rubrique;
  if (Array.isArray(dep.rubriques) && dep.rubriques[0]?.rubrique) return dep.rubriques[0].rubrique;
  if (typeof dep.rubriques === 'object' && dep.rubriques?.rubrique) return dep.rubriques.rubrique;
  return "-";
}

function getSousRubrique(dep) {
  if (dep.sousRubrique) return dep.sousRubrique;
  if (Array.isArray(dep.rubriques) && dep.rubriques[0]?.sousRubrique) return dep.rubriques[0].sousRubrique;
  if (typeof dep.rubriques === 'object' && dep.rubriques?.sousRubrique) return dep.rubriques.sousRubrique;
  return "-";
}

// Remplace grouperDepensesParRubrique par :
function grouperDepensesParRubrique(depenses) {
  const result = {};
  depenses.forEach(dep => {
    const rubrique = getRubrique(dep);
    const sousRubrique = getSousRubrique(dep);
    if (!result[rubrique]) result[rubrique] = {};
    if (!result[rubrique][sousRubrique]) result[rubrique][sousRubrique] = [];
    result[rubrique][sousRubrique].push(dep);
  });
  return result;
}

const ComptableDashboard = () => {
  const [activeView, setActiveView] = useState('dashboard');
  const [projectName, setProjectName] = useState('');
  const [projectDescription, setProjectDescription] = useState('');
  const [responsableChantier, setResponsableChantier] = useState('');
  
  // 🆕 NOUVEAU : Budgets avec gestion des fournisseurs
  const [budgets, setBudgets] = useState({});
  const [fournisseurs, setFournisseurs] = useState({});
  const [showImmoHistory, setShowImmoHistory] = useState(false);
  const [entries, setEntries] = useState([]);
  const [depenses, setDepenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [historique, setHistorique] = useState({ valides: [], refusees: [] });
  const [loadingHistorique, setLoadingHistorique] = useState(false);
  const [rejetsDGIds, setRejetsDGIds] = useState(new Set());
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [depenseToReject, setDepenseToReject] = useState(null);
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState('');
  const motifRef = useRef();
  const [notification, setNotification] = useState(null);
  
  // Auto-clear notification after 1.5 seconds
  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        setNotification(null);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [notification]);
  
  const [depensesValideesEtat, setDepensesValideesEtat] = useState([]);
  const [chargesStructure, setChargesStructure] = useState([]);
  const [loadingChargesStructure, setLoadingChargesStructure] = useState(false);
  const [showChargeAttenteModal, setShowChargeAttenteModal] = useState(false);
  const [chargeToHold, setChargeToHold] = useState(null);
  const [motifAttenteCharge, setMotifAttenteCharge] = useState('');
  const [showChargesHistory, setShowChargesHistory] = useState(false);
  const [showJustificatifModal, setShowJustificatifModal] = useState(false);
  const [justificatifUrl, setJustificatifUrl] = useState(null);
  const [waitingImmoNotifications, setWaitingImmoNotifications] = useState([]);
  const [validatedImmoNotifications, setValidatedImmoNotifications] = useState([]);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [hiddenWaitingImmoNotifIds, setHiddenWaitingImmoNotifIds] = useState(() =>
    JSON.parse(localStorage.getItem("hiddenWaitingImmoNotifIds_CG") || "[]")
  );
  const [hiddenValidatedImmoNotifIds, setHiddenValidatedImmoNotifIds] = useState(() =>
    JSON.parse(localStorage.getItem("hiddenValidatedImmoNotifIds_CG") || "[]")
  );

  // In NotificationsView component, add badge span for unseen notifications
  // Also call markAsSeen when user clicks on notification details

  // ===== ÉTATS POUR LES IMMOBILISATIONS =====
  const [immobilisations, setImmobilisations] = useState([]);
  
  // Loading states pour prévenir les doubles clics
  const [validatingDepenseMEAIds, setValidatingDepenseMEAIds] = useState(new Set());
  const [validatingChargeIds, setValidatingChargeIds] = useState(new Set());
  const [validatingImmoIds, setValidatingImmoIds] = useState(new Set());
  const [validatingDepenseIds, setValidatingDepenseIds] = useState(new Set());
  const [loadingImmobilisations, setLoadingImmobilisations] = useState(false);
  const [showImmoAttenteModal, setShowImmoAttenteModal] = useState(false);
  const [immoToHold, setImmoToHold] = useState(null);
  const [motifAttenteImmo, setMotifAttenteImmo] = useState('');

  // Nouveaux états pour les sous-vues (onglets)
  const [chargesSubView, setChargesSubView] = useState('aTraiter'); // 'aTraiter' ou 'enAttente'

  const [filtreDateDebut, setFiltreDateDebut] = useState('');
  const [filtreDateFin, setFiltreDateFin] = useState('');
  const [etatLoading, setEtatLoading] = useState(false);

  // ===== ÉTATS POUR LES CHARGES MISES EN ATTENTE PAR CG =====
  const [chargesEnAttenteCG, setChargesEnAttenteCG] = useState([]);
  const [loadingChargesEnAttenteCG, setLoadingChargesEnAttenteCG] = useState(false);

  // ===== ÉTATS POUR LES DÉPENSES MISES EN ATTENTE CG =====
  const [depensesMEA, setDepensesMEA] = useState([]);
  const [selectedMEAProject, setSelectedMEAProject] = useState(null);
  const [showMEAActionModal, setShowMEAActionModal] = useState(false);
  const [actionType, setActionType] = useState(null); // 'validate' ou 'mea'
  const [selectedMEADepense, setSelectedMEADepense] = useState(null);
  const motifMEAActionRef = useRef();
  const [viewedUpdatesMEA, setViewedUpdatesMEA] = useState(() =>
    JSON.parse(localStorage.getItem("viewedUpdatesMEA_CG") || "[]")
  );

  // ===== ÉTATS POUR LES DÉPENSES MODIFIÉES DU TABLEAU DE BORD =====
  const [viewedUpdatesRT, setViewedUpdatesRT] = useState(() =>
    JSON.parse(localStorage.getItem("viewedUpdatesRT_CG") || "[]")
  );

  // ===== ÉTATS POUR LES CHARGES MODIFIÉES =====
  const [viewedChargeUpdates, setViewedChargeUpdates] = useState(() =>
    JSON.parse(localStorage.getItem("viewedChargeUpdates_CG") || "[]")
  );

  // ===== ÉTATS POUR LES IMMOBILISATIONS MODIFIÉES =====
  const [viewedImmoUpdates, setViewedImmoUpdates] = useState(() =>
    JSON.parse(localStorage.getItem("viewedImmoUpdates_CG") || "[]")
  );

  // ===== FONCTION POUR MARQUER UNE DÉPENSE MEA COMME VUE =====
  const markMEAAsViewed = (depenseId) => {
    const updateKey = `depensemeaCG-${depenseId}`;
    if (!viewedUpdatesMEA.includes(updateKey)) {
      const newViewed = [...viewedUpdatesMEA, updateKey];
      setViewedUpdatesMEA(newViewed);
      localStorage.setItem("viewedUpdatesMEA_CG", JSON.stringify(newViewed));
      
      // Marquer comme vue dans la base de données avec gestion d'erreur
      pb.collection('depensemea').update(depenseId, {
        hasNewUpdate: false,
        viewedByCG: true,
        dateViewedByCG: new Date().toISOString()
      }).catch(error => {
        console.error("Erreur lors du marquage comme vu:", error);
        // L'erreur n'empêche pas l'interface de fonctionner
      });
    }
  };

  // ===== FONCTION POUR MARQUER UNE DÉPENSE RT COMME VUE =====
  const markRTAsViewed = (depenseId) => {
    const updateKey = `depensesValideesRT-${depenseId}`;
    if (!viewedUpdatesRT.includes(updateKey)) {
      const newViewed = [...viewedUpdatesRT, updateKey];
      setViewedUpdatesRT(newViewed);
      localStorage.setItem("viewedUpdatesRT_CG", JSON.stringify(newViewed));
      
      // Marquer comme vue dans la base de données avec gestion d'erreur
      pb.collection('depensesValideesRT').update(depenseId, {
        hasNewUpdate: false,
        viewedByCG: true,
        dateViewedByCG: new Date().toISOString()
      }).catch(error => {
        console.error("Erreur lors du marquage comme vu:", error);
        // L'erreur n'empêche pas l'interface de fonctionner
      });
    }
  };

  // ===== FONCTION POUR MARQUER UNE CHARGE MODIFIÉE COMME VUE =====
  const markChargeUpdateAsViewed = (chargeId) => {
    const updateKey = `chargeMEA-${chargeId}`;
    if (!viewedChargeUpdates.includes(updateKey)) {
      const newViewed = [...viewedChargeUpdates, updateKey];
      setViewedChargeUpdates(newViewed);
      localStorage.setItem("viewedChargeUpdates_CG", JSON.stringify(newViewed));
      
      pb.collection('chargemea').update(chargeId, {
        hasNewUpdate: false,
        viewedByCG: true,
        dateViewedByCG: new Date().toISOString()
      }).catch(error => {
        console.error("Erreur lors du marquage de la charge comme vue:", error);
      });
    }
  };

  // ===== FONCTION POUR MARQUER UNE IMMO MODIFIÉE COMME VUE =====
  const markImmoUpdateAsViewed = (immoId) => {
    const updateKey = `immoMEA-${immoId}`;
    if (!viewedImmoUpdates.includes(updateKey)) {
      const newViewed = [...viewedImmoUpdates, updateKey];
      setViewedImmoUpdates(newViewed);
      localStorage.setItem("viewedImmoUpdates_CG", JSON.stringify(newViewed));
      
      pb.collection('immomea').update(immoId, {
        hasNewUpdate: false,
        viewedByCG: true,
        dateViewedByCG: new Date().toISOString()
      }).catch(error => {
        console.error("Erreur lors du marquage de l'immo comme vue:", error);
      });
    }
  };

  // ===== FONCTION POUR CHARGER LES DÉPENSES MISES EN ATTENTE (CG) =====
const chargerDepensesMEA = async () => {
    try {
      // Interroger uniquement la collection des dépenses en attente mises en attente par le DG
      // ...existing code...
      const dataCG = await pb.collection('depensemea').getFullList({ filter: 'meaPar = "DG"', sort: '-created', requestKey: null }).catch(() => []);
      // Filtrer côté client pour exclure les statuts validés ou déjà mis en attente par CG
      // ET ne garder que celles avec un nom de projet défini
      const depensesPourCG = dataCG
        .filter(d => d.status !== 'ValidéCG' && d.status !== 'Mise en attente' && d.meaPar !== "Controleur de Gestion" && (d.nomProjet || d.projectNom || d.projet?.nom || d.expand?.projet?.nom))
        .map(d => ({ ...d, sourceCollection: 'depensemeaCG' }));
      setDepensesMEA(depensesPourCG || []);
// ...existing code...

      setDepensesMEA(depensesPourCG || []);
    } catch (error) {
      console.error("Erreur lors du chargement des dépenses mises en attente :", error);
      setDepensesMEA([]);
      setNotification({ 
        type: 'error', 
        text: 'Erreur lors du chargement des dépenses mises en attente. Vérifiez la connexion.' 
      });
    }
  };

  // ===== FONCTION POUR VALIDER UNE DÉPENSE DEPUIS MEA =====
  const validerDepenseMEA = async (depense) => {
    setValidatingDepenseMEAIds(prev => new Set(prev).add(depense.id));
    try {
      const formData = new FormData();

      const nomProjet =
        depense.nomProjet ||
        depense.projectNom ||
        depense.nom ||
        depense.projet?.nom ||
        depense.expand?.projet?.nom ||
        "Projet non spécifié";

      const donneesValidation = {
        nomProjet,
        chefChantier: depense.chefChantier,
        fournisseur: depense.fournisseur, 
        description: depense.description,
        montant: parseFloat(depense.montant),
        status: 'Validé',
        createdBy: pb.authStore.model.id,
        dateValidationCG: new Date().toISOString(),
        dateValidation: new Date().toISOString(),
        rubriques: typeof depense.rubriques === 'string' 
          ? depense.rubriques 
          : JSON.stringify(depense.rubriques)
      };

      for (const [key, value] of Object.entries(donneesValidation)) {
        if (value !== undefined && value !== null) {
          formData.append(key, value.toString());
        }
      }

      if (depense.justificatif) {
        const fileUrl = pb.files.getUrl(depense, depense.justificatif);
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const file = new File([blob], depense.justificatif, { type: blob.type });
        formData.append('justificatif', file);
      }

      // Créer dans depensesValideesCG
      await pb.collection('depensesValideesCG').create(formData);

      // Marquer comme traité dans depensemeaCG
      await pb.collection('depensemea').update(depense.id, {
        status: 'ValidéCG',
        dateValidationCG: new Date().toISOString(),
        dateValidation: new Date().toISOString(),
        etat: 'traité'
      });

      setNotification({ type: 'success', text: 'Dépense validée avec succès depuis la mise en attente !' });
      setDepensesMEA(prev => prev.filter(d => d.id !== depense.id));

    } catch (error) {
      console.error('Erreur lors de la validation depuis MEA:', error);
      setNotification({ type: 'error', text: 'Erreur lors de la validation.' });
    } finally {
      setValidatingDepenseMEAIds(prev => {
        const newSet = new Set(prev);
        newSet.delete(depense.id);
        return newSet;
      });
    }
  };

  // ===== FONCTION POUR REMETTRE EN ATTENTE UNE DÉPENSE MEA AVEC NOUVEAU MOTIF =====
  const remettreEnAttenteMEA = async (depense, nouveauMotif) => {
    try {
      const formData = new FormData();

      const nomProjet =
        depense.nomProjet ||
        depense.projectNom ||
        depense.nom ||
        depense.projet?.nom ||
        depense.expand?.projet?.nom ||
        "Projet non spécifié";

      const donneesMEA = {
        nomProjet,
        chefChantier: depense.chefChantier,
        fournisseur: depense.fournisseur,
        description: depense.description,
        montant: parseFloat(depense.montant),
        status: 'en_attente_CG',
        createdBy: pb.authStore.model.id,
        datemea: new Date().toISOString(),
        rubriques: typeof depense.rubriques === 'string'
          ? depense.rubriques
          : JSON.stringify(depense.rubriques),
        motif: nouveauMotif,
        meaPar:"Controleur de Gestion",
        hasNewUpdate: true,
        updateCount: (depense.updateCount || 0) + 1,
        dateModification: new Date().toISOString()
      };

      for (const [key, value] of Object.entries(donneesMEA)) {
        if (value !== undefined && value !== null) {
          formData.append(key, value.toString());
        }
      }

      if (depense.justificatif) {
        const fileUrl = pb.files.getUrl(depense, depense.justificatif);
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const file = new File([blob], depense.justificatif, { type: blob.type });
        formData.set('justificatif', file);
      }

      // Mettre à jour l'enregistrement existant avec le nouveau motif
      await pb.collection('depensemea').update(depense.id, formData);

      setNotification({ type: 'success', text: 'Motif de mise en attente mis à jour avec succès !' });
      chargerDepensesMEA(); // Recharger la liste

    } catch (error) {
      console.error('Erreur lors de la mise à jour du motif:', error);
      setNotification({ type: 'error', text: 'Erreur lors de la mise à jour.' });
    }
  };

  // ===== FONCTION POUR OUVRIR LA MODALE D'ACTION =====
  const openMEAActionModal = (depense, type) => {
    setSelectedMEADepense(depense);
    setActionType(type);
    setShowMEAActionModal(true);
  };

  // ===== FONCTION POUR CONFIRMER L'ACTION =====
  const confirmMEAAction = () => {
    if (actionType === 'validate') {
      validerDepenseMEA(selectedMEADepense);
      setShowMEAActionModal(false);
    } else if (actionType === 'mea') {
      const motif = motifMEAActionRef.current.value.trim();
      if (!motif) {
        alert("Veuillez saisir un motif de mise en attente.");
        return;
      }
      remettreEnAttenteMEA(selectedMEADepense, motif);
      setShowMEAActionModal(false);
    }
    setSelectedMEADepense(null);
    setActionType(null);
  };

  

// ===== CHARGEMENT DES DÉPENSES MISE EN ATTENTE =====
  useEffect(() => {
  if (activeView !== "historiqueDepensesAttente") return;
  setLoadingHistorique(true);
  pb.collection('depensemea')
  .getFullList({
    filter: 'meaPar = "Controleur de Gestion"',
    sort: '-created'
  })
  .then(data => {
    setDepensesMEA(data);
    setLoadingHistorique(false);
  })
    .catch(() => setLoadingHistorique(false));
}, [activeView]);

  // ===== CHARGEMENT ET ÉCOUTE EN TEMPS RÉEL DES DÉPENSES MEA (CG) =====
  useEffect(() => {
    if (activeView !== "depensesMEA") return;

    // Chargement initial
    chargerDepensesMEA();

    let unsubscribe = null;

    const setupSubscription = async () => {
      try {
        const unsub = await pb.collection('depensemea').subscribe('*', chargerDepensesMEA);
        unsubscribe = unsub;
      } catch (error) {
        console.error("Erreur lors de la souscription à depensemeaCG:", error);
      }
    };

    setupSubscription();

    // Nettoyage à la destruction du composant
    return () => {
      if (unsubscribe) {
        try {
          unsubscribe();
        } catch (error) {
          console.error("Erreur lors de la désouscription:", error);
        }
      }
    };
  }, [activeView]);

  // ===== CHARGEMENT ET MISE À JOUR EN TEMPS RÉEL DES CHARGES MISES EN ATTENTE PAR CG =====
  useEffect(() => {
    if (activeView !== 'chargesStructure') return;

    let unsubChargemea = null;
    let unsubChargesStructure = null;

    const fetchCharges = async () => {
      setLoadingChargesStructure(true);
      try {
        // 1. Récupérer les nouvelles charges depuis la collection principale
        const nouvellesCharges = await pb.collection('chargesStructure').getFullList({
          filter: "statut = 'en attente'",
          sort: '-created',
        });

        // 2. Récupérer les charges modifiées/mises en attente depuis chargemea
        const chargesModifiees = await pb.collection('chargemea').getFullList({
          filter: '(statut = "en attente" || statut = "modifiée") && meaPar != "Controleur de Gestion" && meaPar != "DG"',
          sort: '-created',
        });

        // 3. Combiner les deux listes
        setChargesStructure([...nouvellesCharges, ...chargesModifiees]);
      } catch (error) {
        console.error("Erreur lors de la récupération des charges de structure:", error);
        setNotification({
          type: 'error',
          text: "Erreur lors du chargement des charges de structure."
        });
        setChargesStructure([]);
      }
      setLoadingChargesStructure(false);
    };

    // Chargement initial
    fetchCharges();

    // Souscrire aux événements dans chargesStructure pour mise à jour en temps réel
    pb.collection('chargesStructure').subscribe('*', (e) => {
      console.log('chargesStructure event:', e);
      fetchCharges();
    })
      .then(unsub => { unsubChargesStructure = unsub; })
      .catch(err => console.error("Subscription error for chargesStructure:", err));

    // Souscrire aux événements dans chargemea
    pb.collection('chargemea').subscribe('*', (e) => {
      console.log('chargemea event:', e);
      fetchCharges();
    })
      .then(unsub => { unsubChargemea = unsub; })
      .catch(err => console.error("Subscription error for chargemea:", err));

    return () => {
      if (unsubChargemea) unsubChargemea();
      if (unsubChargesStructure) unsubChargesStructure();
    };
  }, [activeView]);

  // ===== CHARGEMENT ET MISE À JOUR EN TEMPS RÉEL DES IMMOBILISATIONS =====
  useEffect(() => {
    let unsubImmo = null;
    let unsubImmoMEA = null;
    let unsubImmoCreate = null;

    // Charger les immobilisations à traiter
    const fetchImmobilisationsATraiter = async () => {
      try {
        const data = await pb.collection('immobilisation').getFullList({
          filter: "statut = 'en attente'",
          sort: '-created',
        });
        // Ne mettre à jour l'état que si on est sur la bonne vue
        if (activeView === 'immobilisations') {
          setImmobilisations(data);
          setLoadingImmobilisations(false);
        }
      } catch (error) {
        console.error("Erreur chargement immobilisations à traiter:", error);
        if (activeView === 'immobilisations') {
          setImmobilisations([]);
          setLoadingImmobilisations(false);
        }
      }
    };

    // Charger les immobilisations mises en attente par DG (pour notifications)
    const fetchImmoMEA = async () => {
      try {
        const data = await pb.collection('immomea').getFullList({
          filter: 'meaPar = "DG" && statut != "traité"',
          sort: '-created',
        });
        // Toujours mettre à jour les notifications
        setWaitingImmoNotifications(
          data.filter(notif => !hiddenWaitingImmoNotifIds.includes(notif.id))
        );
      } catch (error) {
        console.error("Erreur chargement immobilisations MEA:", error);
      }
    };

    // Fetch initial seulement si on est sur la bonne vue
    if (activeView === 'immobilisations') {
      setLoadingImmobilisations(true);
      fetchImmobilisationsATraiter();
    }
    fetchImmoMEA();

    // Subscriptions - toujours actives pour les notifications
    pb.collection('immobilisation').subscribe('*', (e) => {
      console.log('immobilisation event:', e);
      fetchImmobilisationsATraiter();
    })
      .then(unsub => { unsubImmo = unsub; })
      .catch(err => console.error("Subscription error for immobilisation:", err));

    // Subscription pour les immobilisations mises en attente par DG
    pb.collection('immomea').subscribe('*', (e) => {
      console.log('immomea event:', e);
      fetchImmoMEA();
    })
      .then(unsub => { unsubImmoMEA = unsub; })
      .catch(err => console.error("Subscription error for immomea:", err));
      
    // Subscription spéciale pour les créations d'immobilisations
    pb.collection('immobilisation').subscribe('create', (e) => {
      console.log('Nouvelle immobilisation créée:', e);
      // Ajouter la nouvelle immobilisation à la liste si elle a le statut 'en attente'
      if (e.record && e.record.statut === 'en attente') {
        // Ne mettre à jour l'état que si on est sur la bonne vue
        if (activeView === 'immobilisations') {
          setImmobilisations(prev => [e.record, ...prev]);
        }
      }
    })
      .then(unsub => { unsubImmoCreate = unsub; })
      .catch(err => console.error("Subscription error for immobilisation create:", err));
      
    return () => {
      if (unsubImmo) unsubImmo();
      if (unsubImmoMEA) unsubImmoMEA();
      if (unsubImmoCreate) unsubImmoCreate();
    };
  }, [activeView, hiddenWaitingImmoNotifIds]);

  const rubriques = {
  "Terrain": ["Achat terrain", "Enregistrement", "Publication foncière", "Commission", "Autre"],
  "Gros Œuvre": ["Clôture", "Excavation & démolition", "Travaux", "Autre"],
  "Architecture & Ingénierie": [
    "Architecture", "Bureau de contrôle", "Assurance décennale", "Urbanisme", "Étude", "Géomètre",
    "Plan BA", "Plan lots techniques", "Notice de sécurité", "Publication règlement de copropriété",
    "Frais de dossier autorisation", "Impôt et taxes", "Taxes diverses / notaire", "Impression & copie plan", "Autre"
  ],
  "Matériaux de Construction": [
    "Acier & fer", "Ciment", "Gravier & basalte", "Briques", "Sable",
    "Divers matériels & outillage", "Autre"
  ],
  "Aluminium": ["Fournitures", "Pose", "Fournitures & pose", "Divers", "Autre"],
  "Carrelage": ["Fournitures", "Pose", "Fournitures & pose", "Divers", "Quintal", "Autre"],
  "Cuisines": ["Fournitures", "Pose", "Fournitures & pose", "Divers", "Quintal", "Autre"],
  "CVC (Climatisation, Ventilation, Chauffage)": ["Fournitures", "Pose", "Fournitures & pose", "Divers", "Autre"],
  "Dressing": ["Fournitures", "Pose", "Fournitures & pose", "Divers", "Autre"],
  "Électricité (CFO + CFA)": [
    "CFO", "CFA", "COSSUEL", "Vidéophone / Domotique", "Fibre optique", "Caméra de surveillance",
    "Fournitures", "Pose", "Consommation électricité", "Frais sur achat", "Quintal", "Autre"
  ],
  "Étanchéité & Cuvelage": ["Fournitures", "Pose", "Fournitures & pose", "Divers", "Autre"],
  "Faux Plafond (Plâtre / BA13)": ["Fournitures", "Pose", "Fournitures & pose", "Divers", "Autre"],
  "Peinture": ["Fournitures", "Pose", "Fournitures & pose", "Divers", "Autre"],
  "Plomberie": ["Fournitures", "Pose", "Fournitures & pose", "Divers", "Quintal", "Autre"],
  "Portes": ["Fournitures", "Pose", "Fournitures & pose", "Divers", "Quintal", "Autre"],
  "Meubles & Décoration": [
    "Meubles offerts à la résidence", "Enseigne", "Tableau camouflage compteur", "Mobilier jardin",
    "Mobilier terrasse piscine", "Salle polyvalente", "Accessoires décoratifs", "Salon hall d'accueil",
    "Équipement salle de sport", "Pergola", "Desk concierge", "Lambris décoratif", "Autre"
  ],
  "Machineries": ["Groupe électrogène", "Aquarium", "Suppresseur", "Piscine", "Ascenseur", "Autre"],
  "Réseaux": ["Poste transformateur", "ONAS", "Ageroute", "Sonatel", "SEN EAU", "Autre"],
  "Sécurité Incendie": ["Sécurité incendie", "Frais sur achat", "Autre"],
  "Logistique": ["Container dédouanement", "Container déchargement", "Taxes municipales", "Autre"],
  "Divers": [
    "Ouvrier & nettoyage", "Divers travaux", "Location matériel chantier", "Réparation matériel",
    "Gardiennage", "Divers matériels & outillage", "Consommation eau/électricité", "Enseigne et décoration", "Autre"
  ]
};

  // 🆕 FONCTION pour créer les lignes budgétaires avec fournisseurs
  const createEntriesFromBudgets = () => {
    const entriesArray = [];
    
    Object.keys(rubriques).forEach(rubrique => {
      rubriques[rubrique].forEach(sousRubrique => {
        const key = `${rubrique}_${sousRubrique}`;
        const fournisseursList = fournisseurs[key] || [];
        
        if (fournisseursList.length > 0) {
          // Créer une entrée par fournisseur
          fournisseursList.forEach(fournisseur => {
            if (fournisseur.nom && fournisseur.budget > 0) {
              entriesArray.push({
                id: Date.now() + Math.random(),
                rubrique,
                sousRubrique,
                estime: Number(fournisseur.budget),
                fournisseur: fournisseur.nom,
                budgetfournisseur: Number(fournisseur.budget),
                statut: 'planifie'
              });
            }
          });
        } else {
          // Mode classique sans fournisseurs
          const budget = budgets[key];
          if (budget && Number(budget) > 0) {
            entriesArray.push({
              id: Date.now() + Math.random(),
              rubrique,
              sousRubrique,
              estime: Number(budget),
              fournisseur: '',
              budgetfournisseur: Number(budget),
              statut: 'planifie'
            });
          }
        }
      });
    });
    
    return entriesArray;
  };

  // Fonction pour mettre à jour un budget spécifique
  const updateBudget = (rubrique, sousRubrique, value) => {
    const key = `${rubrique}_${sousRubrique}`;
    setBudgets(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // Fonction pour ajouter un fournisseur à une sous-rubrique
  const addFournisseur = (rubrique, sousRubrique) => {
    const key = `${rubrique}_${sousRubrique}`;
    setFournisseurs(prev => ({
      ...prev,
      [key]: [...(prev[key] || []), { id: Date.now(), nom: '', budget: 0 }]
    }));
  };

  // Fonction pour mettre à jour un fournisseur
  const updateFournisseur = (rubrique, sousRubrique, fournisseurId, field, value) => {
    const key = `${rubrique}_${sousRubrique}`;
    setFournisseurs(prev => ({
      ...prev,
      [key]: (prev[key] || []).map(f => 
        f.id === fournisseurId ? { ...f, [field]: field === 'budget' ? Number(value) || 0 : field === 'nom' ? value.toUpperCase() : value } : f
      )
    }));
  };

  // Fonction pour supprimer un fournisseur
  const removeFournisseur = (rubrique, sousRubrique, fournisseurId) => {
    const key = `${rubrique}_${sousRubrique}`;
    setFournisseurs(prev => ({
      ...prev,
      [key]: (prev[key] || []).filter(f => f.id !== fournisseurId)
    }));
  };

  // Calcul du total des budgets saisis (avec fournisseurs)
  const calculateTotalFromFournisseurs = (rubrique, sousRubrique) => {
    const key = `${rubrique}_${sousRubrique}`;
    const fournisseursList = fournisseurs[key] || [];
    return fournisseursList.reduce((sum, f) => sum + (f.budget || 0), 0);
  };

  const totalEstime = Object.keys(rubriques).reduce((total, rubrique) => {
    return total + rubriques[rubrique].reduce((sum, sousRubrique) => {
      const key = `${rubrique}_${sousRubrique}`;
      const fournisseursList = fournisseurs[key] || [];
      if (fournisseursList.length > 0) {
        return sum + fournisseursList.reduce((fSum, f) => fSum + (f.budget || 0), 0);
      }
      return sum + (Number(budgets[key]) || 0);
    }, 0);
  }, 0);

  const handleCreateProject = async () => {
    if (!projectName || !projectDescription || !responsableChantier) {
      alert('Veuillez remplir tous les champs obligatoires (nom, description, responsable).');
      return;
    }
    console.log("Fournisseurs:", fournisseurs);
    console.log("Budgets:", budgets);
    // Créer les entries depuis les budgets saisis
    const projectEntries = createEntriesFromBudgets();
    
    if (projectEntries.length === 0) {
      alert('Veuillez saisir au moins un budget pour créer le projet.');
      return;
    }

    const projectData = {
      name: projectName,
      description: projectDescription,
      responsableChantier,
      entries: projectEntries,
      fournisseur: Object.values(fournisseurs).flat().map(f => f.nom ? f.nom.toUpperCase() : '').filter(Boolean).join(', '), // Convertir en string et forcer majuscules
      budgetfournisseur: totalEstime.toString(), // Convertir en string
      budgetTotal: totalEstime,
      status: 'en_attente',
      createdBy: 'controleur'
    };

    console.log("Project Data:", projectData); // Log the project data being sent
    try {
      await createProject(projectData);
      alert('Projet créé avec succès !');
      setActiveView('projets');
      // Reset tous les champs
      setBudgets({});
      setProjectName('');
      setProjectDescription('');
      setResponsableChantier('');
    } catch (error) {
      console.error('Erreur lors de la création du projet :', error);
      alert("Erreur lors de la création du projet. Veuillez réessayer.");
    }
  };

  const [depensesTraitees, setDepensesTraitees] = useState(() => {
    const saved = localStorage.getItem('depensesTraiteesCG');
    return saved ? JSON.parse(saved) : [];
  });

  // Récupérer les dépenses validées par le responsable technique (sans doublons)
  useEffect(() => {
    
    let unsubscribe = null;
    setLoading(true);
    console.log("📡 URL utilisée :", pb.baseUrl);
    const chargerDepenses = async () => {
      try {
        // Charger uniquement les dépenses en attente de validation par CG
        const data = await pb.collection('depensesValideesRT').getFullList({
          filter: 'status = "en_attente_CG"',
          sort: '-created',
        });
        
        // Filtrer pour s'assurer qu'on n'a que les éléments non traités
       const filteredData = data.filter(dep => 
          dep.status === 'en_attente_CG' && dep.etat !== 'traité'
        );
        
        setDepenses(filteredData);
      } catch (error) {
        console.error("Erreur lors du chargement des dépenses:", error);
        setDepenses([]);
      }
      setLoading(false);
    };

    chargerDepenses();

    pb.collection('depensesValideesRT').subscribe('*', function (e) {
      chargerDepenses();
    }).then(function(subscription) {
      unsubscribe = subscription;
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

    // Récupérer les charges de structure à traiter (correction)
    useEffect(() => {
      if (activeView !== 'chargesStructure') return;

      let unsubChargemea = null;
      let unsubChargesStructure = null;

      const fetchCharges = async () => {
        setLoadingChargesStructure(true);
        try {
          // 1. Récupérer les nouvelles charges depuis la collection principale
          const nouvellesCharges = await pb.collection('chargesStructure').getFullList({
            filter: "statut = 'en attente'",
            sort: '-created',
          });

          // 2. Récupérer les charges modifiées/mises en attente depuis chargemea
          const chargesModifiees = await pb.collection('chargemea').getFullList({
            filter: '(statut = "en attente" || statut = "modifiée") && meaPar != "Controleur de Gestion" && meaPar != "DG"',
            sort: '-created',
          });
          
          // 3. Combiner les deux listes
          setChargesStructure([...nouvellesCharges, ...chargesModifiees]);
        } catch (error) {
          console.error("Erreur lors de la récupération des charges de structure:", error);
          setNotification({
            type: 'error',
            text: "Erreur lors du chargement des charges de structure."
          });
          setChargesStructure([]);
        }
        setLoadingChargesStructure(false);
      };

      fetchCharges();

      // Souscrire aux deux collections pour les mises à jour en temps réel
      pb.collection('chargemea').subscribe('*', fetchCharges)
        .then(unsub => { unsubChargemea = unsub; })
        .catch(err => console.error("Subscription error for chargemea:", err));

      pb.collection('chargesStructure').subscribe('*', fetchCharges)
        .then(unsub => { unsubChargesStructure = unsub; })
        .catch(err => console.error("Subscription error for chargesStructure:", err));

      return () => {
        if (unsubChargemea) unsubChargemea();
        if (unsubChargesStructure) unsubChargesStructure();
      };
    }, [activeView]);

  const NotificationBox = () =>
    notification ? (
      <div
        className={`fixed top-20 right-8 z-50 px-6 py-4 rounded shadow-lg text-white font-semibold transition-all
          ${notification.type === 'success' ? 'bg-green-600' : 'bg-red-600'}`}
      >
        {notification.text}
        <button
          className="ml-4 text-white font-bold"
          onClick={() => setNotification(null)}
        >
          ×
        </button>
      </div>
    ) : null;

  function getDepenseId(depense) {
    return depense.id || depense._id || depense.key || (depense.expand && depense.expand.id) || null;
  }

  const handleValider = async (depense) => {
    setValidatingDepenseIds(prev => new Set(prev).add(depense.id));
    try {
      const formData = new FormData();

      const nomProjet =
        depense.nomProjet ||
        depense.projectNom ||
        depense.nom ||
        depense.projet?.nom ||
        depense.expand?.projet?.nom ||
        "Projet non spécifié";

      const donneesValidation = {
        nomProjet,
        chefChantier: depense.chefChantier,
        fournisseur: depense.fournisseur,
        description: depense.description,
        montant: parseFloat(depense.montant),
        status: 'Validé',
        createdBy: pb.authStore.model.id,
        dateValidationCG: new Date().toISOString(),
        dateValidation: new Date().toISOString(),
        rubriques: typeof depense.rubriques === 'string'
          ? depense.rubriques
          : JSON.stringify(depense.rubriques)
      };

      for (const [key, value] of Object.entries(donneesValidation)) {
        if (value !== undefined && value !== null) {
          formData.append(key, value.toString());
        }
      }

      if (depense.justificatif) {
        const fileUrl = pb.files.getUrl(depense, depense.justificatif);
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const file = new File([blob], depense.justificatif, { type: blob.type });
        formData.append('justificatif', file);
      }

      await pb.collection('depensesValideesCG').create(formData);

      // Marquer l'original comme traité pour éviter qu'il réapparaisse
      await pb.collection('depensesValideesRT').update(depense.id, {
        status: 'ValidéCG',
        dateValidationCG: new Date().toISOString(),
        dateValidation: new Date().toISOString(),
        etat: 'traité',
        processed: true
      });

      setNotification({ type: 'success', text: 'Dépense validée avec succès !' });
      
      // Retirer immédiatement de la liste locale
      setDepenses(prev => prev.filter(d => d.id !== depense.id));

    } catch (error) {
      console.error('Erreur détaillée:', error);
      setNotification({ type: 'error', text: 'Erreur lors de la validation.' });
    } finally {
      setValidatingDepenseIds(prev => {
        const newSet = new Set(prev);
        newSet.delete(depense.id);
        return newSet;
      });
    }
  };

  // PARTIE NOTIFICATIONS EN ATTENTE/VALIDÉES (remplace la logique rejetée)
  const [activeNotifTab, setActiveNotifTab] = useState("en_attente");
  const [waitingNotifications, setWaitingNotifications] = useState([]);
  const [validatedNotifications, setValidatedNotifications] = useState([]);
  const [notifLoading, setNotifLoading] = useState(false);
  const [selectedNotif, setSelectedNotif] = useState(null);
  const [selectedNotifProject, setSelectedNotifProject] = useState(null);
  const [selectedWaitingImmoProject, setSelectedWaitingImmoProject] = useState(null);

  // Charges notifications (updated to reflect new requirements)
  const [waitingChargesNotifications, setWaitingChargesNotifications] = useState([]);
  const [validatedChargesNotifications, setValidatedChargesNotifications] = useState([]);

  const [hiddenWaitingNotifIds, setHiddenWaitingNotifIds] = useState(() => {
    return JSON.parse(localStorage.getItem("hiddenWaitingNotifIds_CG") || "[]");
  });
  const [hiddenValidatedNotifIds, setHiddenValidatedNotifIds] = useState(() => {
    return JSON.parse(localStorage.getItem("hiddenValidatedNotifIds_CG") || "[]");
  });

  const [hiddenWaitingChargesNotifIds, setHiddenWaitingChargesNotifIds] = useState(() => {
    return JSON.parse(localStorage.getItem("hiddenWaitingChargesNotifIds_CG") || "[]");
  });
  const [hiddenValidatedChargesNotifIds, setHiddenValidatedChargesNotifIds] = useState(() => {
    return JSON.parse(localStorage.getItem("hiddenValidatedChargesNotifIds_CG") || "[]");
  });

  // Add states to track seen notifications for badges
  const [seenWaitingNotifIds, setSeenWaitingNotifIds] = useState(() => {
    return JSON.parse(localStorage.getItem("seenWaitingNotifIds_CG") || "[]");
  });
  const [seenWaitingChargesNotifIds, setSeenWaitingChargesNotifIds] = useState(() => {
    return JSON.parse(localStorage.getItem("seenWaitingChargesNotifIds_CG") || "[]");
  });
  const [seenWaitingImmoNotifIds, setSeenWaitingImmoNotifIds] = useState(() => {
    return JSON.parse(localStorage.getItem("seenWaitingImmoNotifIds_CG") || "[]");
  });
  const [seenValidatedNotifIds, setSeenValidatedNotifIds] = useState(() => {
    return JSON.parse(localStorage.getItem("seenValidatedNotifIds_CG") || "[]");
    });
  const [seenValidatedChargesNotifIds, setSeenValidatedChargesNotifIds] = useState(() =>
    JSON.parse(localStorage.getItem("seenValidatedChargesNotifIds_CG") || "[]")
  );
  const [seenValidatedImmoNotifIds, setSeenValidatedImmoNotifIds] = useState(() =>
    JSON.parse(localStorage.getItem("seenValidatedImmoNotifIds_CG") || "[]")
  );

  // Function to mark a waiting notification as seen
  const markWaitingNotifAsSeen = (notifId) => {
    setSeenWaitingNotifIds(prev => {
      if (prev.includes(notifId)) return prev;
      const newSeen = [...prev, notifId];
      localStorage.setItem("seenWaitingNotifIds_CG", JSON.stringify(newSeen));
      return newSeen;
    });
  };

  // Function to mark a waiting charge notification as seen
  const markWaitingChargeNotifAsSeen = (notifId) => {
    setSeenWaitingChargesNotifIds(prev => {
      if (prev.includes(notifId)) return prev;
      const newSeen = [...prev, notifId];
      localStorage.setItem("seenWaitingChargesNotifIds_CG", JSON.stringify(newSeen));
      return newSeen;
    });
  };

  // Function to mark a waiting immobilisation notification as seen
  const markWaitingImmoNotifAsSeen = (notifId) => {
    setSeenWaitingImmoNotifIds(prev => {
      if (prev.includes(notifId)) return prev;
      const newSeen = [...prev, notifId];
      localStorage.setItem("seenWaitingImmoNotifIds_CG", JSON.stringify(newSeen));
      return newSeen;
    });
  };

  // Function to mark a validated expense notification as seen
  const markValidatedNotifAsSeen = (notifId) => {
    setSeenValidatedNotifIds(prev => {
      if (prev.includes(notifId)) return prev;
      const newSeen = [...prev, notifId];
      localStorage.setItem("seenValidatedNotifIds_CG", JSON.stringify(newSeen));
      return newSeen;
    });
  };

  // Function to mark a validated charge notification as seen
  const markValidatedChargeNotifAsSeen = (notifId) => {
    setSeenValidatedChargesNotifIds(prev => {
      if (prev.includes(notifId)) return prev;
      const newSeen = [...prev, notifId];
      localStorage.setItem("seenValidatedChargesNotifIds_CG", JSON.stringify(newSeen));
      return newSeen;
    });
  };

  // Function to mark a validated immobilisation notification as seen
  const markValidatedImmoNotifAsSeen = (notifId) => {
    setSeenValidatedImmoNotifIds(prev => {
      if (prev.includes(notifId)) return prev;
      const newSeen = [...prev, notifId];
      localStorage.setItem("seenValidatedImmoNotifIds_CG", JSON.stringify(newSeen));
      return newSeen;
    });
  };


  // Fonction pour masquer localement une notification et persister dans le localStorage
  const hideNotification = (notif, type) => {
    if (type === "en_attente") {
      setHiddenWaitingNotifIds(prev => {
        const updated = [...prev, notif.id];
        localStorage.setItem("hiddenWaitingNotifIds_CG", JSON.stringify(updated));
        return updated;
      });
      // Remove immediately from local state
      setWaitingNotifications(prev => prev.filter(n => n.id !== notif.id));
    } else if (type === "validées") {
      setHiddenValidatedNotifIds(prev => {
        const updated = [...prev, notif.id];
        localStorage.setItem("hiddenValidatedNotifIds_CG", JSON.stringify(updated));
        return updated;
      });
      setValidatedNotifications(prev => prev.filter(n => n.id !== notif.id));
    }
  };

  // Fonction pour masquer une dépense mise en attente immédiatement
  const hideExpenseOnHold = (expenseId) => {
    setHiddenWaitingNotifIds(prev => {
      if (!prev.includes(expenseId)) {
        const updated = [...prev, expenseId];
        localStorage.setItem("hiddenWaitingNotifIds_CG", JSON.stringify(updated));
        return updated;
      }
      return prev;
    });
    // Remove immediately from local state
    setWaitingNotifications(prev => prev.filter(n => n.id !== expenseId));
  };

  // Fonction pour masquer localement une notification de charge
  const hideChargeNotification = (notif, type) => {
    if (type === "en_attente") {
      setHiddenWaitingChargesNotifIds(prev => {
        const updated = [...prev, notif.id];
        localStorage.setItem("hiddenWaitingChargesNotifIds_CG", JSON.stringify(updated));
        return updated;
      });
      setWaitingChargesNotifications(prev => prev.filter(n => n.id !== notif.id));
    } else if (type === "validées") {
      setHiddenValidatedChargesNotifIds(prev => {
        const updated = [...prev, notif.id];
        localStorage.setItem("hiddenValidatedChargesNotifIds_CG", JSON.stringify(updated));
        return updated;
      });
      setValidatedChargesNotifications(prev => prev.filter(n => n.id !== notif.id));
    }
  };

  const hideImmoNotification = (notif, type) => {
    if (type === "en_attente") {
      setHiddenWaitingImmoNotifIds(prev => {
        const updated = [...prev, notif.id];
        localStorage.setItem("hiddenWaitingImmoNotifIds_CG", JSON.stringify(updated));
        return updated;
      });
      setWaitingImmoNotifications(prev => prev.filter(n => n.id !== notif.id));
    } else if (type === "validées") {
      setHiddenValidatedImmoNotifIds(prev => {
        const updated = [...prev, notif.id];
        localStorage.setItem("hiddenValidatedImmoNotifIds_CG", JSON.stringify(updated));
        return updated;
      });
      setValidatedImmoNotifications(prev => prev.filter(n => n.id !== notif.id));
    }
  };

  // ...déclare la fonction UNE SEULE FOIS avant le useEffect...
let isLoadingWaiting = false;
const chargerWaitingNotifications = async () => {
  if (isLoadingWaiting) return;
  isLoadingWaiting = true;
  try {
    const data = await pb.collection('depensemea').getFullList({ filter: 'meaPar = "DG"', sort: '-created' });
    setWaitingNotifications(
      data.filter(
        notif =>
          notif.status !== "Mise en attente" &&
          notif.status !== "ValidéCG" &&
          notif.status !== "Validé" &&
          !hiddenWaitingNotifIds.includes(notif.id) &&
          (notif.nomProjet || notif.projectNom || notif.projet?.nom || notif.expand?.projet?.nom)
      )
    );
  } catch (error) {
    console.error(error);
  } finally {
    isLoadingWaiting = false;
    setNotifLoading(false);
  }
};

// ...dans le useEffect, appelle simplement la fonction sans la redéfinir...
useEffect(() => {
  if (activeView !== "notifications") return;
  setNotifLoading(true);

  chargerWaitingNotifications();

  const chargerValidatedNotifications = async () => {
    const data = await pb.collection('depensesValideesDG').getFullList({ sort: '-created' });
    setValidatedNotifications(
      data.filter(notif => !hiddenValidatedNotifIds.includes(notif.id))
    );
  };

  const chargerWaitingChargesNotifications = async () => {
    try {
      const data = await pb.collection('chargemea').getFullList({
        filter: 'meaPar = "DG" && (statut = "en attente" || statut = "modifiée")',
        sort: '-created'
      });
      setWaitingChargesNotifications(
        data.filter(notif => !hiddenWaitingChargesNotifIds.includes(notif.id))
      );
    } catch (error) {
      setWaitingChargesNotifications([]);
      console.error("Erreur lors du chargement des charges mises en attente DG:", error);
    }
  };

  // ...existing code...
  const chargerValidatedChargesNotifications = async () => {
    try {
      // Retire le filtre sur 'statut'
      const data = await pb.collection('chargesValideesDG').getFullList({
        sort: '-created'
      });
      setValidatedChargesNotifications(
        data.filter(notif => !hiddenValidatedChargesNotifIds.includes(notif.id))
      );
    } catch (error) {
      console.error("Erreur lors du chargement des charges validées DG:", error);
      setValidatedChargesNotifications([]);
    }
  };
// ...existing code...

  // Appel initial
  chargerValidatedNotifications();
  chargerWaitingChargesNotifications();
  chargerValidatedChargesNotifications();

  // Souscriptions temps réel
  let unsubWaiting = null;
  let unsubValidated = null;
  let unsubWaitingCharges = null;
  let unsubValidatedCharges = null;

  pb.collection('depensemea').subscribe('*', chargerWaitingNotifications).then(unsub => { unsubWaiting = unsub; });
  pb.collection('depensesValideesDG').subscribe('*', chargerValidatedNotifications).then(unsub => { unsubValidated = unsub; });
  pb.collection('chargemea').subscribe('*', chargerWaitingChargesNotifications).then(unsub => { unsubWaitingCharges = unsub; });
  pb.collection('chargesValideesDG').subscribe('*', chargerValidatedChargesNotifications).then(unsub => { unsubValidatedCharges = unsub; });

  // Nettoyage à la destruction du composant
  return () => {
    if (unsubWaiting) unsubWaiting();
    if (unsubValidated) unsubValidated();
    if (unsubWaitingCharges) unsubWaitingCharges();
    if (unsubValidatedCharges) unsubValidatedCharges();
  };
}, [
  activeView,
  hiddenWaitingNotifIds,
  hiddenValidatedNotifIds,
  hiddenWaitingChargesNotifIds,
  hiddenValidatedChargesNotifIds
]);
  function getProjetNom(notif) {
    // First, check if the notification is linked to a project.
    const projetNom =
      notif.nomProjet ||
      notif.projectNom ||
      notif.nom ||
      notif.projet?.nom ||
      notif.expand?.projet?.nom;
    if (projetNom) {
      return projetNom;
    }

    // If there's no project, check if it's an immobilisation.
    if (notif.collectionName === 'immomea' || notif.collectionName === 'immoValideesDG') {
      return "Immo";
    }
    
    // For all other cases without a project (charges, etc.), keep the original behavior.
    return "Charges";
  }

  function groupByProjet(notifs) {
    return notifs.reduce((acc, notif) => {
      const projetNom = getProjetNom(notif);
      if (!acc[projetNom]) acc[projetNom] = [];
      acc[projetNom].push(notif);
      return acc;
    }, {});
  }

  const totalNotifications =
    waitingNotifications.length +
    validatedNotifications.length +
    waitingChargesNotifications.length +
    validatedChargesNotifications.length +
    waitingImmoNotifications.length +
    validatedImmoNotifications.length;

  function handleDescriptionClick(description) {
    setSelectedDescription(description);
    setShowDescriptionModal(true);
  }

  function getJustificatifUrl(depense) {
    if (!depense || !depense.justificatif) return null;
    return pb.files.getUrl(depense, depense.justificatif);
  }

  async function handleValiderChargeStructure(charge) {
    try {
      // 1. Créer une copie dans chargesValideesCG
      await pb.collection('chargesValideesCG').create({
        rubrique: charge.rubrique,
        description: charge.description,
        montant: charge.montant,
        statut: 'validé',
        dateValidationCG: new Date().toISOString(),
        createdBy: charge.createdBy,
      });

      // 2. Mettre à jour le statut de la charge originale en fonction de sa provenance
      if (charge.collectionName === 'chargemea') {
        // La charge vient des notifications (mise en attente par DG)
        await pb.collection('chargemea').update(charge.id, {
          statut: 'Validé par CG',
          meaPar: 'Traité', // Exclure de la liste des notifications DG
        });
        // Mettre à jour l'état des notifications
        setWaitingChargesNotifications(prev => prev.filter(c => c.id !== charge.id));
        setChargesEnAttenteCG(prev => prev.filter(c => c.id !== charge.id));
      } else {
        // Comportement original pour les charges venant de la page principale
        await pb.collection('chargesStructure').update(charge.id, {
          statut: 'validé',
        });
        // Mettre à jour l'état des charges de structure
        setChargesStructure(prev => prev.filter(c => c.id !== charge.id));
      }

      setNotification({ type: 'success', text: 'Charge validée avec succès !' });

    } catch (error) {
      console.error("Erreur lors de la validation de la charge:", error);
      setNotification({ type: 'error', text: 'Erreur lors de la validation de la charge.' });
    }
  }
  async function handleMettreEnAttenteCharge(charge) {
    setChargeToHold(charge);
    setShowChargeAttenteModal(true);
  }

  async function confirmMettreEnAttenteCharge() {
    if (!motifAttenteCharge.trim()) {
      setNotification({ type: 'error', text: 'Le motif est requis.' });
      return;
    }
    if (!chargeToHold) return;

    try {
      // Cas 1: La charge vient des notifications (déjà dans chargemea)
      // ...existing code...
// Cas 1: La charge vient des notifications (déjà dans chargemea)
      if (chargeToHold.collectionName === 'chargemea') {
        // 1. Marquer l'ancienne comme traitée (optionnel, pour l'historique)
        await pb.collection('chargemea').update(chargeToHold.id, {
          statut: 'traitée',
          dateTraitement: new Date().toISOString(),
        });
        // 2. Créer une nouvelle charge mise en attente
        await pb.collection('chargemea').create({
          rubrique: chargeToHold.rubrique,
          description: chargeToHold.description,
          montant: chargeToHold.montant,
          statut: 'en attente',
          motif: motifAttenteCharge,
          datemea: new Date().toISOString(),
          createdBy: chargeToHold.createdBy,
          meaPar: 'Controleur de Gestion',
          hasNewUpdate: true,
          updateCount: (chargeToHold.updateCount || 0) + 1,
          dateModification: new Date().toISOString(),
        });

        // AJOUT ICI : retire la charge de la liste des notifications en attente
        setWaitingChargesNotifications(prev => prev.filter(c => c.id !== chargeToHold.id));

        // 3. Mettre à jour le statut de la charge originale
        let hiddenIds = JSON.parse(localStorage.getItem('hiddenNotifications') || '[]');
        hiddenIds = hiddenIds.filter(id => id !== chargeToHold.id);
        localStorage.setItem('hiddenNotifications', JSON.stringify(hiddenIds));
      }

      // Cas 2: La charge vient de la page principale des charges de structure
      else {
        // 1. Créer une copie dans chargemea
        await pb.collection('chargemea').create({
          rubrique: chargeToHold.rubrique,
          description: chargeToHold.description,
          montant: chargeToHold.montant,
          statut: 'en attente',
          motif: motifAttenteCharge,
          datemea: new Date().toISOString(),
          createdBy: chargeToHold.createdBy,
          meaPar: 'Controleur de Gestion',
          hasNewUpdate: true, // Pour notifier la page des charges
        });

        // 2. Mettre à jour le statut de la charge originale
        await pb.collection('chargesStructure').update(chargeToHold.id, {
          statut: 'en attente CG',
        });

        // 3. Mettre à jour l'état local
        setChargesStructure(prev => prev.filter(c => c.id !== chargeToHold.id));
      }
      
      setNotification({ type: 'success', text: 'Charge mise en attente avec succès.' });

    } catch (error) {
      console.error("Erreur lors de la mise en attente de la charge:", error);
      setNotification({ type: 'error', text: 'Erreur lors de la mise en attente de la charge.' });
    } finally {
      setShowChargeAttenteModal(false);
      setMotifAttenteCharge('');
      setChargeToHold(null);
    }
  }

  // ===== GESTION DES IMMOBILISATIONS EN ATTENTE =====
  // ...après le useEffect de notifications...
useEffect(() => {
  if (activeView !== "notifications") return;

  // Immobilisations en attente (par DG)
  pb.collection('immomea').getFullList({
    filter: 'meaPar = "DG" && statut != "traité"',
    sort: '-created'
  }).then(data => {
    setWaitingImmoNotifications(
      data.filter(notif => !hiddenWaitingImmoNotifIds.includes(notif.id))
    );
  });

  // Immobilisations validées par DG
  pb.collection('immoValideesDG').getFullList({ sort: '-created' }).then(data => {
    setValidatedImmoNotifications(
      data.filter(notif => !hiddenValidatedImmoNotifIds.includes(notif.id))
    );
  });

  // Souscriptions temps réel
  let unsubWaitingImmo = null;
  let unsubValidatedImmo = null;
  pb.collection('immomea').subscribe('*', () => {
    pb.collection('immomea').getFullList({
      filter: 'meaPar = "DG" && statut != "traité"',
      sort: '-created'
    }).then(data => {
      setWaitingImmoNotifications(
        data.filter(notif => !hiddenWaitingImmoNotifIds.includes(notif.id))
      );
    });
  }).then(unsub => { unsubWaitingImmo = unsub; });
  pb.collection('immoValideesDG').subscribe('*', () => {
    pb.collection('immoValideesDG').getFullList({ sort: '-created' }).then(data => {
      setValidatedImmoNotifications(
        data.filter(notif => !hiddenValidatedImmoNotifIds.includes(notif.id))
      );
    });
  }).then(unsub => { unsubValidatedImmo = unsub; });

  return () => {
    if (unsubWaitingImmo) unsubWaitingImmo();
    if (unsubValidatedImmo) unsubValidatedImmo();
  };
}, [activeView, hiddenWaitingImmoNotifIds, hiddenValidatedImmoNotifIds]);

  // ===== GESTION DES IMMOBILISATIONS =====
  // ...autour de la ligne 1125...
  // ...dans la fonction handleValiderImmobilisation...
  async function handleValiderImmobilisation(immo) {
    try {
      // Si l'immobilisation vient de la collection immomea (mise en attente par DG)
      if (immo.collectionName === 'immomea' || immo.meaPar) {
        // 1. Créer dans immoValideesCG
        await pb.collection('immoValideesCG').create({
          montant: immo.montant,
          description: immo.description,
          rubrique: immo.rubrique?.rubrique
            ? immo.rubrique
            : { rubrique: immo.rubrique, sousRubrique: immo.sousRubrique },
          dateValidationCG: new Date().toISOString(),
        });
        // 2. Supprimer de immomea
        await pb.collection('immomea').delete(immo.id);
        // 3. Mettre à jour l'état local
        setWaitingImmoNotifications(prev => prev.filter(i => i.id !== immo.id));
      } else {
        // Cas classique (validation d'une immobilisation normale)
        await pb.collection('immoValideesCG').create({
          montant: immo.montant,
          description: immo.description,
          rubrique: immo.rubrique?.rubrique
            ? immo.rubrique
            : { rubrique: immo.rubrique, sousRubrique: immo.sousRubrique },
          dateValidationCG: new Date().toISOString(),
        });
        await pb.collection('immobilisation').update(immo.id, {
          statut: 'traité',
          lastModified: new Date().toISOString(),
        });
        setImmobilisations(prev => prev.filter(i => i.id !== immo.id));
      }
      setNotification({ type: 'success', text: 'Immobilisation validée avec succès !' });
    } catch (error) {
      console.error("Erreur lors de la validation de l'immobilisation:", error);
      setNotification({ type: 'error', text: 'Erreur lors de la validation.' });
    }
}

  // ===== GESTION DE LA DÉCONNEXION =====
  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    // Clear PocketBase authentication
    pb.authStore.clear();
    
    // Clear localStorage items related to authentication
    localStorage.removeItem('pocketbase_auth');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userEmail');
    
    // Clear all viewed notifications to force re-authentication
    localStorage.removeItem('viewedUpdatesRT_CG');
    localStorage.removeItem('viewedUpdatesMEA_CG');
    localStorage.removeItem('viewedChargeUpdates_CG');
    localStorage.removeItem('viewedImmoUpdates_CG');
    localStorage.removeItem('hiddenWaitingNotifIds_CG');
    localStorage.removeItem('hiddenValidatedNotifIds_CG');
    localStorage.removeItem('hiddenWaitingChargesNotifIds_CG');
    localStorage.removeItem('hiddenValidatedChargesNotifIds_CG');
    localStorage.removeItem('hiddenWaitingImmoNotifIds_CG');
    localStorage.removeItem('hiddenValidatedImmoNotifIds_CG');
    localStorage.removeItem('seenWaitingNotifIds_CG');
    localStorage.removeItem('seenValidatedNotifIds_CG');
    localStorage.removeItem('seenWaitingChargesNotifIds_CG');
    localStorage.removeItem('seenValidatedChargesNotifIds_CG');
    localStorage.removeItem('seenWaitingImmoNotifIds_CG');
    localStorage.removeItem('seenValidatedImmoNotifIds_CG');
    
    // Prevent browser back button access
    window.history.pushState(null, null, '/login');
    window.history.replaceState(null, null, '/login');
    
    // Redirect to login page
    window.location.href = '/login';
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  function handleMettreEnAttenteImmobilisation(immo) {
    setImmoToHold(immo);
    setShowImmoAttenteModal(true);
  }

  // ...juste après handleValiderImmobilisation...
  async function confirmMettreEnAttenteImmobilisation() {
    if (!motifAttenteImmo.trim()) {
      setNotification({ type: 'error', text: 'Le motif est requis.' });
      return;
    }
    if (!immoToHold) return;

    try {
      // Si la demande vient des notifications (déjà dans immomea)
      if (immoToHold.collectionName === 'immomea' || immoToHold.meaPar) {
        await pb.collection('immomea').update(immoToHold.id, {
          motif: motifAttenteImmo,
          meaPar: 'Controleur Gestion',
          datemea: new Date().toISOString(),
        });
        setWaitingImmoNotifications(prev => prev.filter(i => i.id !== immoToHold.id));
      } else {
        // Sinon, création dans immomea
        await pb.collection('immomea').create({
          montant: immoToHold.montant,
          description: immoToHold.description,
          datemea: new Date().toISOString(),
          motif: motifAttenteImmo,
          meaPar: 'Controleur Gestion',
          statut: 'en attente',
          rubrique: {
            rubrique: immoToHold.rubrique,
            sousRubrique: immoToHold.sousRubrique,
          },
        });
        await pb.collection('immobilisation').update(immoToHold.id, {
          statut: 'traité',
          lastModified: new Date().toISOString(),
        });
        setImmobilisations(prev => prev.filter(i => i.id !== immoToHold.id));
      }

      setNotification({ type: 'success', text: 'Immobilisation mise en attente avec succès.' });
    } catch (error) {
      console.error("Erreur lors de la mise en attente de l'immobilisation:", error);
      setNotification({ type: 'error', text: 'Erreur lors de la mise en attente.' });
    } finally {
      setShowImmoAttenteModal(false);
      setMotifAttenteImmo('');
      setImmoToHold(null);
    }
  }


  // Remplace les anciens états liés au rejet par ceux pour la mise en attente
  const [showAttenteModal, setShowAttenteModal] = useState(false);
  const [depenseToAttente, setDepenseToAttente] = useState(null);
  const [motifAttente, setMotifAttente] = useState('');

  // Fonction pour ouvrir la modale de mise en attente
  function handleMettreEnAttente(depense) {
    setDepenseToAttente(depense);
    setShowAttenteModal(true);
  }

  // Fonction pour confirmer la mise en attente et stocker dans depensemeaCG
  async function confirmMettreEnAttente() {
    if (!motifAttente.trim()) {
      setNotification({ type: 'error', text: 'Le motif est requis.' });
      return;
    }
    if (!depenseToAttente) return;

    // Retirer immédiatement de la liste locale avant l'appel serveur
    const depenseId = depenseToAttente.id;
    
    // Retirer de la liste locale des dépenses en attente
    setDepenses(prev => prev.filter(d => d.id !== depenseId));
    
    // Retirer des notifications si c'est une notification
    setWaitingNotifications(prev => prev.filter(n => n.id !== depenseId));

    // Ajouter l'ID à l'état des notifications cachées et persister dans le localStorage.
    // Cela garantit que la notification ne réapparaît pas après une actualisation.
    setHiddenWaitingNotifIds(prev => {
      if (prev.includes(depenseId)) {
        return prev;
      }
      const updated = [...prev, depenseId];
      localStorage.setItem("hiddenWaitingNotifIds_CG", JSON.stringify(updated));
      return updated;
    });

    // Fermer la modale immédiatement
    setShowAttenteModal(false);
    setMotifAttente('');
    setDepenseToAttente(null);

    try {
      const formData = new FormData();
      formData.append('montant', Number(depenseToAttente.montant) || 0);
      formData.append('datemea', new Date().toISOString());
      formData.append('meaPar', 'Controleur de Gestion');
      formData.append('nomProjet', getProjetNom(depenseToAttente));
      formData.append('chefChantier', depenseToAttente.chefChantier ?? '');
      formData.append('fournisseur', depenseToAttente.fournisseur ?? '');
      formData.append('description', depenseToAttente.description ?? '');
      formData.append('status', 'en_attente_CG');
      formData.append('rubriques', depenseToAttente.rubriques
        ? (typeof depenseToAttente.rubriques === 'string'
            ? depenseToAttente.rubriques
            : JSON.stringify(depenseToAttente.rubriques))
        : '');
      formData.append('motif', motifAttente);

      // Gestion du justificatif
      if (depenseToAttente.justificatif) {
        try {
          const fileUrl = pb.files.getUrl(depenseToAttente, depenseToAttente.justificatif);
          const response = await fetch(fileUrl);
          const blob = await response.blob();
          const file = new File([blob], depenseToAttente.justificatif, { type: blob.type });
          formData.append('justificatif', file);
        } catch (fileError) {
          console.warn("Erreur lors de la récupération du justificatif:", fileError);
          // On continue sans le justificatif
        }
      }

      await pb.collection('depensemea').create(formData);
      setWaitingNotifications(prev => prev.filter(n => n.id !== depenseId));

      const sourceCollection = depenseToAttente.collectionName || 'depensesValideesRT';
      await pb.collection(sourceCollection).update(depenseId, {
        status: 'mis_en_attente_par_CG',
        etat: 'traité',
        processed: true,
        dateProcessed: new Date().toISOString()
      });

      setNotification({ type: 'success', text: 'Dépense mise en attente avec succès !' });
      
      // Recharger les dépenses MEA
      await chargerDepensesMEA();
      
    } catch (error) {
      console.error('Erreur PocketBase:', error);
      
      let errorMessage = 'Erreur lors de la mise en attente.';
      const pbError = error.response || error;
      if (pbError.status === 404) {
        errorMessage = 'Collection non trouvée. Contactez l\'administrateur.';
      } else if (pbError.status === 403) {
        errorMessage = 'Permissions insuffisantes pour cette action.';
      } else if (pbError.data) {
        errorMessage = `Erreur de validation: ${JSON.stringify(pbError.data)}`;
      }
      
      setNotification({ type: 'error', text: errorMessage });
    }
  }

  const renderNotifDetailsModal = (notif, type = "waiting") => {
    if (!notif) return null;
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full mx-4 border-4 border-blue-200 animate-fade-in flex flex-col max-h-[90vh]">
          <div className="px-6 py-4 border-b border-blue-100 flex justify-between items-center rounded-t-2xl bg-gradient-to-r from-blue-50 to-blue-100">
            <h3 className="text-lg font-bold text-blue-800 flex items-center gap-2">
              <span className={type === "waiting" ? "text-yellow-500" : "text-green-500"}>
                {type === "waiting" ? "⏸️" : "✓"}
              </span>
              Détails de la dépense {type === "waiting" ? "mise en attente" : "validée"}
            </h3>
            <button
              onClick={() => setSelectedNotif(null)}
              className="text-gray-400 hover:text-gray-600 transition-colors text-2xl"
            >
              ✕
            </button>
          </div>
          <div className="px-6 py-6 bg-gradient-to-br from-blue-50 to-white flex-1 overflow-y-auto">
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-blue-700">Rubrique :</span>
                <span>
                  {notif.rubrique
                    || (Array.isArray(notif.rubriques) && notif.rubriques[0]?.rubrique)
                    || (typeof notif.rubriques === 'object' && notif.rubriques?.rubrique)
                    || notif.rubriques?.nom
                    || "-"
                  }
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-semibold text-blue-700">Sous-rubrique :</span>
                <span>
                  {notif.sousRubrique
                    || (Array.isArray(notif.rubriques) && notif.rubriques[0]?.sousRubrique)
                    || (typeof notif.rubriques === 'object' && notif.rubriques?.sousRubrique)
                    || "-"
                  }
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-semibold text-blue-700">Montant :</span>
                <span className="font-mono text-blue-900">{notif.montant?.toLocaleString()} FCFA</span>
              </div>
              <div>
                <span className="font-semibold text-blue-700">Description :</span>
                <div className="mt-1 bg-blue-50 rounded p-2 text-gray-700">{notif.description || "-"}</div>
              </div>
              {type === "waiting" && (
                <div>
                  <span className="font-semibold text-yellow-700">Motif de la mise en attente :</span>
                  <div className="mt-1 bg-yellow-50 rounded p-2 text-yellow-700">{notif.motif || "-"}</div>
                </div>
              )}
              <div className="flex items-center gap-2">
                <span className="font-semibold text-blue-700">Date :</span>
                <span>
                  {type === "waiting"
                    ? (notif.datemea
                        ? new Date(notif.datemea).toLocaleString()
                        : notif.created
                          ? new Date(notif.created).toLocaleString()
                          : "-")
                    : (notif.dateValidationDG
                        ? new Date(notif.dateValidationDG).toLocaleString()
                        : notif.created
                          ? new Date(notif.created).toLocaleString()
                          : "-")
                  }
                </span>
              </div>
              {notif.fournisseur && (
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-blue-700">Fournisseur :</span>
                  <span>{notif.fournisseur}</span>
                </div>
              )}
              {type === "waiting" && (
                <div>
                  <span className="font-semibold text-blue-700">Mise en attente par :</span>
                  <span className="font-bold">{notif.meaPar || "-"}</span>
                </div>
              )}
            </div>
          </div>
          <div className="px-6 py-4 bg-blue-50 flex justify-end rounded-b-2xl">
            <button
              onClick={() => setSelectedNotif(null)}
              className="px-5 py-2 bg-blue-200 text-blue-900 rounded-lg font-semibold hover:bg-blue-300 transition-colors shadow"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    );
  };

  const newWaitingNotificationsCount = waitingNotifications.filter(
    (n) => n.hasNewUpdate && !viewedUpdatesMEA.includes(`depensemeaCG-${n.id}`)
  ).length;

  const newWaitingChargesNotificationsCount = waitingChargesNotifications.filter(
    (n) => n.hasNewUpdate && !viewedChargeUpdates.includes(`chargeMEA-${n.id}`)
  ).length;

  const newWaitingImmoNotificationsCount = waitingImmoNotifications.filter(
    (n) => n.hasNewUpdate && !viewedImmoUpdates.includes(`immoMEA-${n.id}`)
  ).length;

  const NotificationsView = () => (
    <div className="flex-1 min-h-[calc(100vh-3.5rem)] bg-gray-50 animate-fade-in pl-56 pt-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="mb-4">
          <h2 className="text-2xl font-bold text-blue-800 flex items-center gap-2">
            <span>🔔</span> Centre de notifications
          </h2>
          <p className="mt-2 text-gray-600">Consultez vos notifications de dépenses en attente et validées</p>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6">
          <div className="flex flex-col sm:flex-row gap-4 mb-6">
            {/* Dépenses en attente */}
            <button
              onClick={() => setActiveNotifTab("en_attente")}
              className={`flex-1 px-6 py-3 rounded-lg flex items-center justify-center gap-2 relative ${
                activeNotifTab === "en_attente"
                  ? "bg-yellow-500 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <span className="text-lg">⏸️</span>
              <span className="font-semibold">Dépenses en attente</span>
              <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                activeNotifTab === "en_attente"
                  ? "bg-white text-yellow-600"
                  : "bg-yellow-200 text-yellow-700"
              }`}>
                {waitingNotifications.length}
              </span>
              {newWaitingNotificationsCount > 0 && (
                <span className="absolute -top-1 -right-1 flex h-4 w-4">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-4 w-4 bg-red-500 text-white text-xs justify-center items-center">
                    {newWaitingNotificationsCount}
                  </span>
                </span>
              )}
            </button>
            {/* Dépenses validées */}
            <button
              onClick={() => setActiveNotifTab("validées")}
              className={`flex-1 px-6 py-3 rounded-lg flex items-center justify-center gap-2 ${
                activeNotifTab === "validées"
                  ? "bg-green-600 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <FontAwesomeIcon icon={faCheckCircle} />
              <span className="font-semibold">Dépenses validées</span>
              <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                activeNotifTab === "validées"
                  ? "bg-white text-green-600"
                  : "bg-green-200 text-green-700"
              }`}>
                {validatedNotifications.length}
              </span>
            </button>
            {/* Charges */}
            
            <button
              onClick={() => setActiveNotifTab("charges")}
              className={`flex-1 px-6 py-3 rounded-lg flex items-center justify-center gap-2 relative ${
                activeNotifTab === "charges"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <FontAwesomeIcon icon={faMoneyBillWave} />
              <span className="font-semibold">Charges</span>
              <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                activeNotifTab === "charges"
                  ? "bg-white text-blue-600"
                  : "bg-blue-200 text-blue-700"
              }`}>
                {waitingChargesNotifications.length + validatedChargesNotifications.length}
              </span>
              {newWaitingChargesNotificationsCount > 0 && (
                <span className="absolute -top-1 -right-1 flex h-4 w-4">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-4 w-4 bg-red-500 text-white text-xs justify-center items-center">
                    {newWaitingChargesNotificationsCount}
                  </span>
                </span>
              )}
            </button>

            {/* Immobilisations */}
           
            <button
              onClick={() => setActiveNotifTab("immobilisations")}
              className={`flex-1 px-6 py-3 rounded-lg flex items-center justify-center gap-2 relative ${
                activeNotifTab === "immobilisations"
                  ? "bg-purple-600 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <FontAwesomeIcon icon={faBuilding} />
              <span className="font-semibold">Immobilisations</span>
              <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                activeNotifTab === "immobilisations"
                  ? "bg-white text-purple-600"
                  : "bg-purple-200 text-purple-700"
              }`}>
                {waitingImmoNotifications.length + validatedImmoNotifications.length}
              </span>
              {newWaitingImmoNotificationsCount > 0 && (
                <span className="absolute -top-1 -right-1 flex h-4 w-4">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-4 w-4 bg-red-500 text-white text-xs justify-center items-center">
                    {newWaitingImmoNotificationsCount}
                  </span>
                </span>
              )}
            </button>
          </div>
          <div className="mt-6">
            {notifLoading ? (
              <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
              </div>
            ) : activeNotifTab === "en_attente" ? (
              waitingNotifications.length === 0 ? (
                <div className="text-center py-12 bg-gray-50 rounded-lg">
                  <span className="text-yellow-400 text-4xl mb-3">⏸️</span>
                  <p className="text-gray-600">Aucune dépense en attente</p>
                </div>
              ) : (
                Object.entries(groupByProjet(waitingNotifications)).map(([projetNom, notifs]) => (
                  <div key={projetNom} className="mb-8">
                    <div
                      className={`cursor-pointer bg-gradient-to-br from-yellow-50 to-white rounded-xl shadow-lg p-5 border-l-8 border-yellow-500 mb-4 transition-transform hover:scale-105 hover:shadow-2xl ${
                        selectedNotifProject === projetNom ? "ring-2 ring-yellow-400" : ""
                      }`}
                      onClick={() => setSelectedNotifProject(selectedNotifProject === projetNom ? null : projetNom)}
                    >
                      <div className="flex items-center gap-3">
                        <span className="font-bold text-lg text-yellow-900">{projetNom}</span>
                        <span className="ml-auto bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs font-bold">
                          {notifs.length} dépense{notifs.length > 1 ? "s" : ""}
                        </span>
                      </div>
                    </div>
                    {selectedNotifProject === projetNom && (
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {notifs.map((notif) => {
                          const updateKey = `depensemeaCG-${notif.id}`;
                          const hasNewUpdate = notif.hasNewUpdate && !viewedUpdatesMEA.includes(updateKey);
                          const updateCount = notif.updateCount || 0;

                          return (
                          <div
                            key={notif.id}
                            className="bg-white rounded-lg shadow border-l-4 border-yellow-500 p-3 flex flex-col justify-between min-h-[180px] transition-transform hover:scale-[1.02] hover:shadow-lg relative"
                            style={{ fontSize: "0.93rem" }}
                          >
                          {hasNewUpdate && updateCount > 0 && (
                            <div className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold shadow-lg animate-pulse z-10">
                              {updateCount}
                            </div>
                          )}
                          {/* Add badge for new notification */}
                          {!seenWaitingNotifIds.includes(notif.id) && (
                            <span
                              className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center shadow-lg z-20"
                              style={{ pointerEvents: "none" }}
                            >
                              1
                            </span>
                          )}
                          <div className="flex items-center gap-2 mb-1">
                            <span className="text-yellow-500 text-lg">⏸️</span>
                            <span className="font-semibold text-xs text-yellow-700">Mise en attente</span>
                            {hasNewUpdate && (
                              <span className="bg-red-100 text-red-600 px-1 py-0.5 rounded text-[10px] font-bold ml-2">
                                NOUVEAU
                              </span>
                            )}
                          </div>
                            <div className="text-[11px] text-gray-400 mb-1 italic">
                              {notif.datemea
                                ? new Date(notif.datemea).toLocaleString()
                                : notif.created
                                  ? new Date(notif.created).toLocaleString()
                                  : "-"}
                            </div>
                            <div className="mb-2 space-y-1">
                              <div className="text-xs text-gray-600">
                                <span className="font-semibold text-yellow-700">Motif : </span>
                                <span className="break-words">{notif.motif || "-"}</span>
                              </div>
                              <div className="text-xs text-gray-600">
                                <span className="font-semibold text-yellow-700">Chef de chantier : </span>
                                {notif.chefChantier || "-"}
                              </div>
                              <div className="text-xs font-semibold text-gray-800">
                                <span className="font-semibold text-yellow-700">Montant : </span>
                                {Number(notif.montant).toLocaleString()} FCFA
                              </div>
                              <div className="text-xs text-gray-600">
                                <span className="font-semibold text-yellow-700">Justificatif : </span>
                                {notif.justificatif ? (
                                  <button
                                    className="text-blue-600 hover:underline"
                                    onClick={() => {
                                      setJustificatifUrl(pb.files.getUrl(notif, notif.justificatif));
                                      setShowJustificatifModal(true);
                                    }}
                                  >
                                    Voir
                                  </button>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </div>
                            <hr className="my-2 border-gray-200" />
                            <div className="flex justify-between items-center gap-2">
                            <button
                              className="text-blue-600 hover:underline text-xs font-semibold"
                              onClick={() => {
                                setSelectedNotif(notif);
                                if (!seenWaitingNotifIds.includes(notif.id)) {
                                  markWaitingNotifAsSeen(notif.id);
                                }
                              }}
                            >
                              Détails
                            </button>
                            {/* Bouton EN ATTENTE si pas déjà mis en attente par CG */}
                            {notif.meaPar !== "Controleur de Gestion" && (
                              <button
                                className="text-yellow-600 hover:underline text-xs font-semibold"
                                onClick={() => {
                                  handleMettreEnAttente(notif);
                                  if (!seenWaitingNotifIds.includes(notif.id)) {
                                    markWaitingNotifAsSeen(notif.id);
                                  }
                                }}
                              >
                                En attente
                              </button>
                            )}
                            {/* Bouton VALIDER si déjà mis en attente par CG */}
                            {true && (
                              <button
                                className="text-green-600 hover:underline text-xs font-semibold"
                                onClick={async () => {
                                  if (!seenWaitingNotifIds.includes(notif.id)) {
                                    markWaitingNotifAsSeen(notif.id);
                                  }
                                  try {
                                    const formData = new FormData();
                                    formData.append('nomProjet', getProjetNom(notif));
                                    formData.append('chefChantier', notif.chefChantier ?? '');
                                    formData.append('fournisseur', notif.fournisseur ?? '');
                                    formData.append('description', notif.description ?? '');
                                    formData.append('montant', Number(notif.montant) || 0);
                                    formData.append('status', 'Validé');
                                    formData.append('createdBy', pb.authStore.model.id);
                                    formData.append('dateValidationCG', new Date().toISOString());
                                    formData.append('dateValidation', new Date().toISOString());
                                    formData.append('rubriques', notif.rubriques
                                      ? (typeof notif.rubriques === 'string'
                                          ? notif.rubriques
                                          : JSON.stringify(notif.rubriques))
                                      : '');
                                    if (notif.justificatif) {
                                      try {
                                        const fileUrl = pb.files.getUrl(notif, notif.justificatif);
                                        const response = await fetch(fileUrl);
                                        const blob = await response.blob();
                                        const file = new File([blob], notif.justificatif, { type: blob.type });
                                        formData.append('justificatif', file);
                                      } catch (fileError) {}
                                    }
                                    await pb.collection('depensesValideesCG').create(formData);
                                    // Après validation (dans validerNotificationCG ou validerDepenseMEA)
                                    await pb.collection('depensemea').update(notif.id, {
                                      status: 'ValidéCG',
                                      dateValidationCG: new Date().toISOString(),
                                      hasNewUpdate: true,
                                      updateCount: (notif.updateCount || 0) + 1,
                                      dateModification: new Date().toISOString()
                                    });
                                    setNotification({ type: 'success', text: 'Dépense validée !' });
                                    setWaitingNotifications(prev => prev.filter(n => n.id !== notif.id));
                                  } catch (error) {
                                    setNotification({ type: 'error', text: 'Erreur lors de la validation.' });
                                  }
                                }}
                              >
                                Valider
                              </button>
                            )}
                          </div>
                          </div>
                        )})}
                      </div>
                    )}
                  </div>
                ))
              )
            ) : activeNotifTab === "validées" ? (
              validatedNotifications.length === 0 ? (
                <div className="text-center py-12 bg-gray-50 rounded-lg">
                  <span className="text-gray-400 text-4xl mb-3">✓</span>
                  <p className="text-gray-600">Aucune notification de validation</p>
                </div>
              ) : (
                Object.entries(groupByProjet(validatedNotifications)).map(([projetNom, notifs]) => (
                  <div key={projetNom} className="mb-8">
                    <div
                      className={`cursor-pointer bg-gradient-to-br from-green-50 to-white rounded-xl shadow-lg p-5 border-l-8 border-green-500 mb-4 transition-transform hover:scale-105 hover:shadow-2xl ${
                        selectedNotifProject === projetNom ? "ring-2 ring-green-400" : ""
                      }`}
                      onClick={() => setSelectedNotifProject(selectedNotifProject === projetNom ? null : projetNom)}
                    >
                      <div className="flex items-center gap-3">
                        <span className="font-bold text-lg text-green-900">{projetNom}</span>
                        <span className="ml-auto bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold">
                          {notifs.length} notification{notifs.length > 1 ? "s" : ""}
                        </span>
                      </div>
                    </div>
                    {selectedNotifProject === projetNom && (
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {notifs.map((notif) => (
                          <div
                            key={notif.id}
                            className="bg-white rounded-lg shadow border-l-4 border-green-500 p-3 flex flex-col justify-between min-h-[180px] transition-transform hover:scale-[1.02] hover:shadow-lg cursor-pointer"
                            style={{ fontSize: "0.93rem" }}
                            onClick={() => {
                              setSelectedNotif(notif);
                              if (!seenValidatedNotifIds.includes(notif.id)) {
                                markValidatedNotifAsSeen(notif.id);
                              }
                            }}
                          >
                            {/* Place le badge ici */}
                          {!seenValidatedNotifIds?.includes(notif.id) && (
                              <span className="fixed top-2 right-2 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center shadow-lg z-20">
                                1
                              </span>
                            )}
                            <div className="flex items-center gap-2 mb-1">
                              <span className="text-green-500 text-lg">✓</span>
                              <span className="font-semibold text-xs text-green-700">Validé par DG</span>
                            </div>
                            <div className="text-[11px] text-gray-400 mb-1 italic">
                              {notif.dateValidation
                                ? new Date(notif.dateValidationDG).toLocaleString()
                                : notif.created
                                  ? new Date(notif.created).toLocaleString()
                                  : "-"}
                            </div>
                            <div className="mb-2 space-y-1">
                              <div className="text-xs text-gray-600">
                                <span className="font-semibold text-green-700">Rubrique : </span>
                                <span className="break-words">{notif.rubrique || "-"}</span>
                              </div>
                              <div className="text-xs text-gray-600">
                                <span className="font-semibold text-green-700">Description : </span>
                                <span className="break-words">{notif.description || "-"}</span>
                              </div>
                              <div className="text-xs font-semibold text-gray-800">
                                <span className="font-semibold text-green-700">Montant : </span>
                                {Number(notif.montant).toLocaleString()} FCFA
                              </div>
                            </div>
                            <hr className="my-2 border-gray-200" />
                            <div className="flex justify-between items-center">
                              <button
                                className="text-blue-600 hover:underline text-xs font-semibold"
                              >
                                Détails
                              </button>
                              <button
                                className="text-red-600 hover:underline text-xs font-semibold"
                                onClick={() => hideNotification(notif, "validées")}
                              >
                                Supprimer
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))
              )
            ) : activeNotifTab === "charges" ? (
              <div className="space-y-8">
                {/* Charges validées par DG */}
                <div>
                  <h3 className="text-lg font-bold mb-4 text-blue-800">Charges validées par DG</h3>
                  {validatedChargesNotifications.length === 0 ? (
                    <div className="text-center py-8 text-gray-500">
                      <FontAwesomeIcon icon={faInbox} className="text-4xl mb-3" />
                      <p>Aucune charge validée</p>
                    </div>
                  ) : (
                    Object.entries(groupByProjet(validatedChargesNotifications)).map(([projetNom, notifs]) => (
                      <div key={projetNom} className="mb-8">
                        <div
                          className={`cursor-pointer bg-gradient-to-br from-blue-50 to-white rounded-xl shadow-lg p-5 border-l-8 border-blue-500 mb-4 transition-transform hover:scale-105 hover:shadow-2xl ${
                            selectedNotifProject === projetNom ? "ring-2 ring-blue-400" : ""
                          }`}
                          onClick={() => setSelectedNotifProject(selectedNotifProject === projetNom ? null : projetNom)}
                        >
                          <div className="flex items-center gap-3">
                            <span className="font-bold text-lg text-blue-900">{projetNom}</span>
                            <span className="ml-auto bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-bold">
                              {notifs.length} charge{notifs.length > 1 ? "s" : ""}
                            </span>
                          </div>
                        </div>
                        {selectedNotifProject === projetNom && (
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                            {notifs.map((notif) => (
                              <div
                                key={notif.id}
                                className="bg-green-50 border-l-4 border-green-600 rounded-lg p-4 shadow relative flex flex-col justify-between"
                                onClick={() => {
                                  if (!seenValidatedChargesNotifIds.includes(notif.id)) {
                                    markValidatedChargeNotifAsSeen(notif.id);
                                  }
                                }}
                              >
                                <div>
                                  {!seenValidatedChargesNotifIds.includes(notif.id) && (
                                    <span className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center shadow-lg z-20">
                                      1
                                    </span>
                                  )}
                                  <div className="flex justify-between items-center mb-2">
                                    <span className="font-bold text-green-700">{notif.rubrique}</span>
                                    <span className="text-xs text-gray-500">{notif.dateValidationDG ? new Date(notif.dateValidationDG).toLocaleString() : "-"}</span>
                                  </div>
                                  <div className="text-gray-700 mb-2">{notif.description}</div>
                                  <div className="font-mono text-green-900">{Number(notif.montant).toLocaleString()} FCFA</div>
                                  <div className="mt-2 text-xs text-green-700 font-semibold">Validée par DG</div>
                                </div>
                                <div className="flex justify-end mt-2 pt-2 border-t border-green-200">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevent card's onClick
                                      hideChargeNotification(notif, "validées");
                                    }}
                                    className="text-red-600 hover:underline text-xs font-semibold"
                                  >
                                    Supprimer
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
                {/* Charges mises en attente par DG */}
                <div>
                  <h3 className="text-lg font-bold mb-4 text-yellow-800">Charges mises en attente par DG</h3>
                  {waitingChargesNotifications.length === 0 ? (
                    <div className="text-center py-8 text-gray-500">
                      <FontAwesomeIcon icon={faInbox} className="text-4xl mb-3" />
                      <p>Aucune charge mise en attente</p>
                    </div>
                  ) : (
                    Object.entries(
                      groupByProjet(waitingChargesNotifications)
                    ).map(([projetNom, notifs]) => (
                      <div key={projetNom} className="mb-8">
                        <div
                          className={`cursor-pointer bg-gradient-to-br from-yellow-50 to-white rounded-xl shadow-lg p-5 border-l-8 border-yellow-500 mb-4 transition-transform hover:scale-105 hover:shadow-2xl ${
                            selectedNotifProject === projetNom ? "ring-2 ring-yellow-400" : ""
                          }`}
                          onClick={() => setSelectedNotifProject(selectedNotifProject === projetNom ? null : projetNom)}
                        >
                          <div className="flex items-center gap-3">
                            <span className="font-bold text-lg text-yellow-900">{projetNom}</span>
                            <span className="ml-auto bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs font-bold">
                              {notifs.length} charge{notifs.length > 1 ? "s" : ""}
                            </span>
                          </div>
                        </div>
                        {selectedNotifProject === projetNom && (
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                            {notifs.map((notif) => {
                              const updateKey = `chargeMEA-${notif.id}`;
                              const hasNewUpdate = notif.hasNewUpdate && !viewedChargeUpdates.includes(updateKey);
                              const updateCount = notif.updateCount || 0;
                              return (
                              <div key={notif.id} className="bg-yellow-50 border-l-4 border-yellow-600 rounded-lg p-4 shadow flex flex-col justify-between relative">
                                {hasNewUpdate && updateCount > 0 && (
                                  <div className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold shadow-lg animate-pulse z-10">
                                    {updateCount}
                                  </div>
                                )}
                                {!seenWaitingChargesNotifIds.includes(notif.id) && (
                                  <span className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center shadow-lg z-20">
                                    1
                                  </span>
                                )}
                                <div>
                                  <div className="flex justify-between items-center mb-2">
                                    <span className="font-bold text-yellow-700">{notif.rubrique}</span>
                                    <span className="text-xs text-gray-500">{notif.datemea ? new Date(notif.datemea).toLocaleString() : "-"}</span>
                                  </div>
                                  {hasNewUpdate && (
                                    <span className="bg-red-100 text-red-600 px-1.5 py-0.5 rounded text-[10px] font-bold mb-2 inline-block">
                                      MODIFIÉ
                                    </span>
                                  )}
                                  <div className="text-gray-700 mb-2">{notif.description}</div>
                                  <div className="font-mono text-yellow-900">{Number(notif.montant).toLocaleString()} FCFA</div>
                                  <div className="mt-2 text-xs text-yellow-700 font-semibold">Mise en attente par DG</div>
                                  <div className="text-xs text-yellow-700 font-semibold">Motif : {notif.motif || "-"}</div>
                                </div>
                                <div className="flex justify-end mt-4 space-x-2">
                                  <button
                                    onClick={() => {
                                      handleValiderChargeStructure(notif);
                                      if(hasNewUpdate) markChargeUpdateAsViewed(notif.id);
                                      if (!seenWaitingChargesNotifIds.includes(notif.id)) {
                                        markWaitingChargeNotifAsSeen(notif.id);
                                      }
                                    }}
                                    className="px-3 py-1 bg-green-100 text-green-700 rounded font-semibold text-xs hover:bg-green-200 transition-colors"
                                  >
                                    Valider
                                  </button>
                                  <button
                                    onClick={() => {
                                      handleMettreEnAttenteCharge(notif);
                                      if(hasNewUpdate) markChargeUpdateAsViewed(notif.id);
                                      if (!seenWaitingChargesNotifIds.includes(notif.id)) {
                                        markWaitingChargeNotifAsSeen(notif.id);
                                      }
                                    }}
                                    className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded font-semibold text-xs hover:bg-yellow-200 transition-colors"
                                  >
                                    En attente
                                  </button>
                                </div>
                              </div>
                            )})}
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            ) : activeNotifTab === "immobilisations" ? (
              <div className="space-y-8">
                {/* Immobilisations validées par DG */}
                <div>
                  <h3 className="text-lg font-bold mb-4 text-purple-800">Immobilisations validées par DG</h3>
                  {validatedImmoNotifications.length === 0 ? (
                    <div className="text-center py-8 text-gray-500">
                      <FontAwesomeIcon icon={faInbox} className="text-4xl mb-3" />
                      <p>Aucune immobilisation validée</p>
                    </div>
                  ) : (
                    Object.entries(groupByProjet(validatedImmoNotifications)).map(([projetNom, notifs]) => (
                      <div key={projetNom} className="mb-8">
                        <div
                          className={`cursor-pointer bg-gradient-to-br from-green-50 to-white rounded-xl shadow-lg p-5 border-l-8 border-purple-600 mb-4 transition-transform hover:scale-105 hover:shadow-2xl ${
                            selectedNotifProject === projetNom ? "ring-2 ring-purple-400" : ""
                          }`}
                          onClick={() => setSelectedNotifProject(selectedNotifProject === projetNom ? null : projetNom)}
                        >
                          <div className="flex items-center gap-3">
                            <span className="font-bold text-lg text-purple-900">{projetNom}</span>
                            <span className="ml-auto bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-xs font-bold">
                              {notifs.length} immobilisation{notifs.length > 1 ? "s" : ""}
                            </span>
                          </div>
                        </div>
                        {selectedNotifProject === projetNom && (
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {notifs.map((notif) => (
                              <div
                                key={notif.id}
                                className="bg-green-50 border-l-4 border-purple-600 rounded-lg p-4 shadow mb-4 relative flex flex-col justify-between"
                                onClick={() => {
                                  if (!seenValidatedImmoNotifIds.includes(notif.id)) {
                                    markValidatedImmoNotifAsSeen(notif.id);
                                  }
                                }}
                              >
                                <div>
                                  {!seenValidatedImmoNotifIds.includes(notif.id) && (
                                    <span className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center shadow-lg z-20">
                                      1
                                    </span>
                                  )}
                                  <div className="flex justify-between items-center mb-2">
                                    <span className="font-bold text-purple-700">{notif.rubrique?.rubrique || notif.rubrique || "-"}</span>
                                    <span className="text-xs text-gray-500">{notif.dateValidationDG ? new Date(notif.dateValidationDG).toLocaleString() : "-"}</span>
                                  </div>
                                  <div className="text-gray-700 mb-2">{notif.description}</div>
                                  <div className="font-mono text-purple-900">{Number(notif.montant).toLocaleString()} FCFA</div>
                                  <div className="mt-2 text-xs text-purple-700 font-semibold">Validée par DG</div>
                                </div>
                                <div className="flex justify-end mt-2 pt-2 border-t border-purple-200">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      hideImmoNotification(notif, "validées");
                                    }}
                                    className="text-red-600 hover:underline text-xs font-semibold"
                                  >
                                    Supprimer
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
                {/* Immobilisations mises en attente par DG */}
                <div>
                  <h3 className="text-lg font-bold mb-4 text-yellow-800">Immobilisations mises en attente par DG</h3>
                  {waitingImmoNotifications.length === 0 ? (
                    <div className="text-center py-8 text-gray-500">
                      <FontAwesomeIcon icon={faInbox} className="text-4xl mb-3" />
                      <p>Aucune immobilisation mise en attente</p>
                    </div>
                  ) : (
                    Object.entries(groupByProjet(waitingImmoNotifications)).map(([projetNom, notifs]) => (
                      <div key={projetNom} className="mb-8">
                        <div
                          className={`cursor-pointer bg-gradient-to-br from-yellow-50 to-white rounded-xl shadow-lg p-5 border-l-8 border-yellow-500 mb-4 transition-transform hover:scale-105 hover:shadow-2xl ${
                            selectedWaitingImmoProject === projetNom ? "ring-2 ring-yellow-400" : ""
                          }`}
                          onClick={() => setSelectedWaitingImmoProject(selectedWaitingImmoProject === projetNom ? null : projetNom)}
                        >
                          <div className="flex items-center gap-3">
                            <span className="font-bold text-lg text-yellow-900">{projetNom}</span>
                            <span className="ml-auto bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs font-bold">
                              {notifs.length} immobilisation{notifs.length > 1 ? "s" : ""}
                            </span>
                          </div>
                        </div>
                        {selectedWaitingImmoProject === projetNom && (
                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {notifs.map((notif) => {
                              const updateKey = `immoMEA-${notif.id}`;
                              const hasNewUpdate = notif.hasNewUpdate && !viewedImmoUpdates.includes(updateKey);
                              const updateCount = notif.updateCount || 0;
                              return (
                              <div key={notif.id} className="bg-yellow-50 border-l-4 border-yellow-600 rounded-lg p-4 shadow mb-4 flex flex-col justify-between relative">
                              {hasNewUpdate && updateCount > 0 && (
                                <div className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold shadow-lg animate-pulse z-10">
                                  {updateCount}
                                </div>
                              )}
                              {/* Add badge for new immobilisation notification */}
                              {!seenWaitingImmoNotifIds.includes(notif.id) && (
                                <span className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center shadow-lg">
                                  1
                                </span>
                              )}
                              <div>
                                <div className="flex justify-between items-center mb-2">
                                  <span className="font-bold text-yellow-700">{notif.rubrique?.rubrique || notif.rubrique || "-"}</span>
                                  <span className="text-xs text-gray-500">{notif.datemea ? new Date(notif.datemea).toLocaleString() : "-"}</span>
                                </div>
                                {hasNewUpdate && (
                                  <span className="bg-red-100 text-red-600 px-1.5 py-0.5 rounded text-[10px] font-bold mb-2 inline-block">
                                    MODIFIÉ
                                  </span>
                                )}
                                <div className="text-gray-700 mb-2">{notif.description}</div>
                                <div className="font-mono text-yellow-900">{Number(notif.montant).toLocaleString()} FCFA</div>
                                <div className="mt-2 text-xs text-yellow-700 font-semibold">Mise en attente par DG</div>
                                <div className="text-xs text-yellow-700 font-semibold">Motif : {notif.motif || "-"}</div>
                              </div>
                              <div className="flex justify-end mt-2 space-x-2">
                                <button
                                  onClick={() => {
                                    handleValiderImmobilisation(notif);
                                    if(!seenWaitingImmoNotifIds.includes(notif.id)) {
                                      markWaitingImmoNotifAsSeen(notif.id);
                                    }
                                  }}
                                  className="px-3 py-1 bg-green-100 text-green-700 rounded font-semibold text-xs hover:bg-green-200 transition-colors"
                                >
                                  Valider
                                </button>
                                <button
                                  onClick={() => {
                                    handleMettreEnAttenteImmobilisation(notif);
                                    if(!seenWaitingImmoNotifIds.includes(notif.id)) {
                                      markWaitingImmoNotifAsSeen(notif.id);
                                    }
                                  }}
                                  className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded font-semibold text-xs hover:bg-yellow-200 transition-colors"
                                >
                                  En attente
                                </button>
                              </div>
                            </div>
                            )})}
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            ) : null}

            
          </div>
        </div>
      </div>
      {selectedNotif && renderNotifDetailsModal(
        selectedNotif,
        activeNotifTab === "en_attente" ? "waiting" : "validated"
      )}
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-100">
      {/* HEADER */}
      <div className="fixed top-0 left-0 right-0 z-50 flex bg-white border-b border-gray-200 px-4 sm:px-6 lg:px-8 h-14 items-center justify-between print:hidden">
        <div className="flex items-center space-x-4 min-w-0">
          <img src="dywanes-logo.png" alt="Dywane Logo" className="h-10 w-auto" />
        </div>
        <div className="flex-1 max-w-lg mx-4">
          <div className="relative text-gray-400 focus-within:text-gray-600">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3">
              <FontAwesomeIcon icon={faSearch} />
            </span>
            <input type="search" placeholder="Rechercher un projet..." className="block w-full rounded-md border border-gray-300 bg-gray-100 py-1.5 pl-10 pr-3 text-sm placeholder-gray-400 focus:border-gray-400 focus:ring-0 focus:outline-none" />
          </div>
        </div>
          <div className="flex items-center space-x-2 min-w-0">
            <div className="flex items-center justify-center w-7 h-7 rounded-full bg-blue-100 text-blue-600 text-sm select-none">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <span className="text-sm truncate min-w-0">controleur</span>
            <button 
              onClick={handleLogout}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
            </button>
          </div>
      </div>

      {/* BODY */}
      <div className="flex flex-1 overflow-hidden">
        {/* SIDEBAR */}
        <nav className="fixed top-14 left-0 z-40 h-[calc(100vh-3.5rem)] bg-gray-900 w-56 flex-shrink-0 px-4 py-6 flex flex-col space-y-6 text-gray-300 text-sm select-none animate-slide-in-left print:hidden overflow-y-auto">
          {/* Modification des classes des boutons pour assurer un alignement uniforme */}
          <button
            onClick={() => setActiveView('dashboard')}
            className={`flex items-center space-x-2 w-full rounded-md px-4 py-2 ${
              activeView === "dashboard"
                ? "bg-blue-800 text-white font-semibold"
                : "hover:text-white"
            }`}
          >
            <FontAwesomeIcon icon={faHome} fixedWidth />
            <span>Tableau de bord</span>
            {/* Compteur des dépenses modifiées */}
            {(() => {
              try {
                const depensesModifiees = Array.isArray(depenses) ? 
                  depenses.filter(d => d.hasNewUpdate && !viewedUpdatesRT.includes(`depensesValideesRT-${d.id}`)).length : 0;
                return depensesModifiees > 0 && (
                  <span className="ml-auto bg-red-600 text-white rounded-full px-2 py-0.5 text-xs font-bold">
                    {depensesModifiees}
                  </span>
                );
              } catch (error) {
                console.error("Erreur lors du calcul du compteur tableau de bord:", error);
                return null;
              }
            })()}
          </button>

          <button
            onClick={() => setActiveView('nouveauProjet')}
            className={`flex items-center space-x-2 w-full rounded-md px-4 py-2 ${
              activeView === "nouveauProjet"
                ? "bg-blue-800 text-white font-semibold"
                : "hover:text-white"
            }`}
          >
            <FontAwesomeIcon icon={faFolderPlus} fixedWidth /><span>Nouveau projet</span>
          </button>

          <button
            onClick={() => setActiveView('projets')}
            className={`flex items-center space-x-2 w-full rounded-md px-4 py-2 ${
              activeView === "projets"
                ? "bg-blue-800 text-white font-semibold"
                : "hover:text-white"
            }`}
          >
            <FontAwesomeIcon icon={faFileAlt} fixedWidth />
            <span>Projets</span>
          </button>

          <button
            onClick={() => setActiveView('notifications')}
            className={`flex items-center space-x-2 w-full rounded-md px-4 py-2 ${
              activeView === "notifications"
                ? "bg-blue-800 text-white font-semibold"
                : "hover:text-white"
            }`}
          >
            <FontAwesomeIcon icon={faBell} fixedWidth />
            <span>Notifications</span>
            {totalNotifications > 0 && (
              <span className="ml-auto bg-red-600 text-white rounded-full px-2 py-0.5 text-xs font-bold">
                {totalNotifications}
              </span>
            )}
          </button>

          <button
            onClick={() => setActiveView('etat')}
            className={`flex items-center space-x-2 w-full rounded-md px-4 py-2 ${
              activeView === "etat"
                ? "bg-blue-800 text-white font-semibold"
                : "hover:text-white"
            }`}
          >
            <span className="w-[1em]">📈</span>
            <span>État</span>
          </button>

          <button
            onClick={() => setActiveView('chargesStructure')}
            className={`flex items-center space-x-2 w-full rounded-md px-4 py-2 ${
              activeView === "chargesStructure"
                ? "bg-blue-800 text-white font-semibold"
                : "hover:text-white"
            }`}
          >
            <FontAwesomeIcon icon={faMoneyBillWave} fixedWidth />
            <span>Charges structure</span>
          </button>

          <button
            onClick={() => setActiveView('immobilisations')}
            className={`flex items-center space-x-2 w-full rounded-md px-4 py-2 ${
              activeView === "immobilisations"
                ? "bg-blue-800 text-white font-semibold"
                : "hover:text-white"
            }`}
          >
            <FontAwesomeIcon icon={faBuilding} fixedWidth />
            <span>Immobilisation</span>
          </button>

          

          <div className="flex-grow" />
          
          {/* Liens du bas de la sidebar */}
          <div className="mt-auto border-t border-gray-700 pt-3">
            <a href="#" className="flex items-center space-x-2 w-full rounded-md px-4 py-2 hover:text-white">
              <FontAwesomeIcon icon={faCog} fixedWidth /><span>Paramètres</span>
            </a>
            <button onClick={handleLogout} className="flex items-center space-x-2 w-full rounded-md px-4 py-2 mt-4 hover:text-white">
              <FontAwesomeIcon icon={faSignOutAlt} fixedWidth /><span>Déconnexion</span>
            </button>
          </div>
        </nav>

        {/* MAIN */}
        <main className="flex-1 overflow-auto p-6 pl-60 pt-20 animate-slide-in-right">
          {/* 🆕 INTERFACE RÉVOLUTIONNAIRE - Formulaire pré-rempli avec toutes les rubriques */}
          {activeView === 'nouveauProjet' && (
            <>
              <div className="space-y-6 bg-white shadow rounded-lg p-6 animate-fade-in">
                <div className="border-b pb-4">
                  <h2 className="text-2xl font-semibold text-blue-800">🚀 Créer un nouveau projet</h2>
                  <p className="text-gray-600 mt-1">Formulaire optimisé : toutes les rubriques pré-remplies, saisissez uniquement vos budgets !</p>
                </div>
                
                {/* Informations générales du projet */}
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <h3 className="font-semibold text-blue-800 mb-4">📋 Informations générales</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input 
                      value={projectName} 
                      onChange={(e) => setProjectName(e.target.value)} 
                      placeholder="Nom du projet *" 
                      className="w-full rounded-md border px-3 py-2 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200" 
                    />
                    <input 
                      value={responsableChantier} 
                      onChange={(e) => setResponsableChantier(e.target.value)} 
                      placeholder="Responsable Chantier *" 
                      className="w-full rounded-md border px-3 py-2 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200" 
                    />
                  </div>
                  <textarea 
                    value={projectDescription}
                    onChange={(e) => setProjectDescription(e.target.value)}
                    placeholder="Description du projet *"
                    className="w-full rounded-md border px-3 py-2 text-sm mt-4 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                    rows={3}
                  />
                  <div className="overflow-x-auto mt-6">
                    <table className="min-w-full border border-blue-200 rounded-lg shadow">
                      <thead className="bg-gradient-to-r from-blue-600 to-blue-500 text-white sticky top-0">
                        <tr>
                          <th className="p-3 text-left font-semibold border-r border-blue-400">Rubrique</th>
                          <th className="p-3 text-left font-semibold border-r border-blue-400">Sous-rubrique</th>
                          <th className="p-3 text-center font-semibold">Budget alloué (FCFA)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(rubriques).map(([rubrique, sousRubriques], rubriqueIndex) => (
                          <React.Fragment key={rubrique}>
                            {/* Ligne de rubrique principale */}
                            <tr className={`${rubriqueIndex % 2 === 0 ? 'bg-blue-50' : 'bg-green-50'} border-t-2 border-gray-300`}>
                              <td className="p-3 font-bold text-blue-900 border-r border-gray-200" rowSpan={sousRubriques.length + 1}>
                                <div className="flex items-center gap-2">
                                  <span className="text-lg">
                                    {rubrique.includes('Terrain') ? '🏗️' :
                                     rubrique.includes('Matériaux') ? '🧱' :
                                     rubrique.includes('Électricité') ? '⚡' :
                                     rubrique.includes('Plomberie') ? '🚰' :
                                     rubrique.includes('Architecture') ? '📐' :
                                     rubrique.includes('Aluminium') ? '🔩' :
                                     rubrique.includes('Carrelage') ? '🏺' :
                                     rubrique.includes('Peinture') ? '🎨' :
                                     rubrique.includes('Sécurité') ? '🔥' :
                                     '📦'}
                                  </span>
                                  <span className="text-xs leading-tight">{rubrique}</span>
                                </div>
                              </td>
                              <td colSpan="2" className="p-2 text-center text-xs text-gray-500 italic">
                                Sous-rubriques disponibles : {sousRubriques.length}
                              </td>
                            </tr>
                            
                            {/* Lignes des sous-rubriques */}
                            {sousRubriques.map((sousRubrique, sousIndex) => {
                              const key = `${rubrique}_${sousRubrique}`;
                              return (
                                <tr key={sousRubrique} className="hover:bg-yellow-50 transition-colors border-b border-gray-100">
                                  <td className="p-3 pl-6 text-gray-700 border-r border-gray-200">
                                    <div className="flex items-center gap-2">
                                      <span className="w-2 h-2 bg-purple-400 rounded-full"></span>
                                      <span className="text-xs">{sousRubrique}</span>
                                    </div>
                                  </td>
                                  <td className="p-2 text-center">
                                    <div className="space-y-2">
                                      {/* Affichage du total des fournisseurs ou du budget classique */}
                                      <div className="text-sm font-semibold">
                                        Total: {calculateTotalFromFournisseurs(rubrique, sousRubrique).toLocaleString()} FCFA
                                      </div>
                                      
                                      {/* Bouton pour ajouter des fournisseurs */}
                                      <button
                                        onClick={() => addFournisseur(rubrique, sousRubrique)}
                                        className="text-blue-600 hover:text-blue-800 text-xs font-semibold flex items-center gap-1"
                                      >
                                        <span className="text-lg">+</span>
                                        Ajouter fournisseur
                                      </button>
                                      
                                      {/* Liste des fournisseurs */}
                                      {(fournisseurs[`${rubrique}_${sousRubrique}`] || []).map((fournisseur) => (
                                        <div key={fournisseur.id} className="flex items-center gap-2 p-2 bg-gray-50 rounded">
                                          <input
                                            type="text"
                                            placeholder="Nom fournisseur"
                                            value={fournisseur.nom}
                                            onChange={(e) => updateFournisseur(rubrique, sousRubrique, fournisseur.id, 'nom', e.target.value)}
                                            className="flex-1 rounded border px-2 py-1 text-xs"
                                          />
                                          <input
                                            type="text"
                                            placeholder="Budget fournisseur"
                                            value={formatNumberWithSeparator(fournisseur.budget)}
                                            onChange={(e) => {
                                              // Enlève les espaces et les caractères non numériques avant de stocker
                                              const rawValue = e.target.value.replace(/[^\d]/g, '');
                                              updateFournisseur(rubrique, sousRubrique, fournisseur.id, 'budget', rawValue);
                                            }}
                                            onBlur={(e) => {
                                              // Formatage avec séparateur de milliers quand on quitte le champ
                                              const value = e.target.value.replace(/[^\d]/g, '');
                                              if (value && !isNaN(value)) {
                                                e.target.value = Number(value).toLocaleString('fr-FR');
                                              }
                                            }}
                                            onFocus={(e) => {
                                              // Retire le formatage pour permettre la modification
                                              e.target.value = e.target.value.replace(/[^\d]/g, '');
                                            }}
                                            className="flex-1 rounded border px-2 py-1 text-xs"
                                          />
                                          <button
                                            onClick={() => removeFournisseur(rubrique, sousRubrique, fournisseur.id)}
                                            className="text-red-600 hover:text-red-800 text-xs font-semibold"
                                          >
                                            Supprimer
                                          </button>
                                        </div>
                                      ))}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        ))}
                        
                        {/* Ligne de total */}
                        <tr className="bg-gradient-to-r from-green-200 to-green-100 font-bold border-t-4 border-green-400">
                          <td colSpan="2" className="p-4 text-right text-green-800">
                            TOTAL BUDGET PROJET
                          </td>
                          <td className="p-4 text-center text-green-800 text-lg">
                            {totalEstime.toLocaleString()} FCFA
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                  <div className="mt-4 text-xs text-gray-600 bg-blue-50 p-3 rounded">
                    💡 <strong>Instructions :</strong>
                    <ul className="mt-1 ml-4 space-y-1">
                      <li>• Saisissez uniquement les budgets pour les rubriques que vous utiliserez</li>
                      <li>• Les cases vides (0 FCFA) ne créeront pas de lignes budgétaires</li>
                      <li>• Le total se calcule automatiquement</li>
                      <li>• Vous pourrez modifier ces budgets après création du projet</li>
                    </ul>
                  </div>
                </div>

                {/* Boutons d'action */}
                <div className="flex justify-between pt-4 border-t">
                  <button
                    onClick={() => {
                      setActiveView('dashboard');
                      setBudgets({});
                      setProjectName('');
                      setProjectDescription('');
                      setResponsableChantier('');
                    }}
                    className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg shadow font-semibold transition-colors"
                  >
                    ❌ Annuler
                  </button>
                  
                  <div className="flex items-center gap-4">
                    <div className="text-right">
                      <div className="text-sm text-gray-600">
                        {Object.values(budgets).filter(b => Number(b) > 0).length} ligne{Object.values(budgets).filter(b => Number(b) > 0).length > 1 ? 's' : ''} budgétaire{Object.values(budgets).filter(b => Number(b) > 0).length > 1 ? 's' : ''}
                      </div>
                      <div className="text-lg font-bold text-blue-700">
                        {totalEstime.toLocaleString()} FCFA
                      </div>
                    </div>
                    
                    <button
                      onClick={handleCreateProject}
                      disabled={totalEstime === 0}
                      className={`px-8 py-3 rounded-xl shadow-lg font-bold text-base transition-all duration-200 ${
                        totalEstime > 0 
                          ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-700 hover:to-blue-600' 
                          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      }`}
                    >
                      🚀 Créer le projet
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Projets */}
          {activeView === 'projets' && (
            <div className="animate-fade-in">
              <ProjetsPage />
            </div>
          )}

          {/* État - Nouveau contenu ajouté */}
          {activeView === 'etat' && (
            <div className="bg-white p-6 rounded-xl shadow border">
              {etatLoading ? (
                <div className="flex justify-center items-center h-32">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-blue-600"></div>
                  <span className="ml-3">Chargement des données...</span>
                </div>
              ) : (
                <EtatFiltrage
                  filtreDateDebut={filtreDateDebut}
                  setFiltreDateDebut={setFiltreDateDebut}
                  filtreDateFin={filtreDateFin}
                  setFiltreDateFin={setFiltreDateFin}
                />
              )}
            </div>
          )}

          {/* Tableau de bord par défaut */}
          {activeView === 'dashboard' && (
            <div className="space-y-6">
              {loading ? (
                <div className="bg-white p-6 rounded-xl shadow border">
                  <div className="flex justify-center items-center h-40">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-700"></div>
                  </div>
                </div>
              ) : depenses.length === 0 ? (
                <div className="bg-white p-6 rounded-xl shadow border">
                  <div className="text-center text-gray-500">
                    <p className="text-lg">Aucune dépense en attente de validation</p>
                  </div>
                </div>
              ) : (
                Object.entries(depensesParProjet(depenses || [])).map(([nomProjet, depensesProjet]) => {
                  const rubriques = grouperDepensesParRubrique(depensesProjet || []);
                  // Compter les dépenses modifiées dans ce projet avec protection
                  const depensesModifiees = Array.isArray(depensesProjet) ? 
                    depensesProjet.filter(d => 
                      d.hasNewUpdate && !viewedUpdatesRT.includes(`depensesValideesRT-${d.id}`)
                    ).length : 0;
                  
                  return (
                    <div key={nomProjet} className="bg-white rounded-xl shadow border mb-8">
                      <div className="px-6 py-4 border-b bg-blue-50 rounded-t-xl flex items-center">
                        <span className="font-bold text-blue-900 text-lg">{nomProjet}</span>
                        <span className="ml-4 bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-bold">
                          {depensesProjet.length} dépense{depensesProjet.length > 1 ? "s" : ""}
                        </span>
                        {/* Badge pour les dépenses modifiées */}
                        {depensesModifiees > 0 && (
                          <span className="ml-2 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-bold animate-pulse">
                            {depensesModifiees} modifiée{depensesModifiees > 1 ? "s" : ""}
                          </span>
                        )}
                      </div>
                      <div className="overflow-x-auto px-6 py-4">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead>
                            <tr>
                              <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider rounded-tl-lg">
                                                               Rubrique
                              </th>
                              <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Sous Rubrique
                              </th>
                              <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Description
                              </th>
                              <th className="px-4 py-3 bg-gray-50 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Montant
                              </th>
                              <th className="px-4 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Date demande
                              </th>
                              <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Fournisseur
                              </th>
                              <th className="px-4 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Actions
                              </th>
                              <th className="px-4 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Justificatif
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {Object.entries(rubriques).map(([rubrique, sousRubriques]) => (
                              <React.Fragment key={rubrique}>
                                <>
                                  <tr className="bg-blue-50">
                                    <td className="px-4 py-3 font-bold text-blue-900" colSpan={8}>
                                      {rubrique}
                                    </td>
                                  </tr>
                                  {Object.entries(sousRubriques).map(([sousRubrique, depensesList]) =>
                                    depensesList.map((depense, index) => {
                                      // Badge NOUVEAU et compteur de modif pour les dépenses RT
                                      const updateKey = `depensesValideesRT-${depense.id}`;
                                      const hasNewUpdate = depense.hasNewUpdate && !viewedUpdatesRT.includes(updateKey);
                                      const updateCount = depense.updateCount || 0;
                                      
                                      return (
                                        <tr key={depense.id} className="hover:bg-gray-50 transition-colors">
                                          <td className="px-4 py-3 relative">
                                            {/* Badge du nombre de modifications */}
                                            {hasNewUpdate && updateCount > 0 && (
                                              <div className="absolute -top-1 -left-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold shadow-lg animate-pulse z-10">
                                                {updateCount}
                                              </div>
                                            )}
                                          </td>
                                          <td className="px-4 py-3 text-purple-700 font-semibold relative">
                                            {sousRubrique}
                                            {hasNewUpdate && (
                                              <span className="bg-red-100 text-red-600 px-1 py-0.5 rounded text-[10px] font-bold ml-2">
                                                NOUVEAU
                                              </span>
                                            )}
                                          </td>
                                          <td className="px-4 py-3 text-sm text-blue-700 underline cursor-pointer max-w-xs truncate text-center"
                                              onClick={() => {
                                                setSelectedDescription(depense.description || "-");
                                                setShowDescriptionModal(true);
                                                if (hasNewUpdate) {
                                                  markRTAsViewed(depense.id);
                                                }
                                              }}>
                                            {depense.description ? "Lire" : "-"}
                                          </td>
                                          <td className="px-4 py-3 whitespace-nowrap text-sm text-right font-semibold text-gray-900">
                                            {Number(depense.montant).toLocaleString()} FCFA
                                          </td>
                                          <td className="px-4 py-3 whitespace-nowrap text-sm text-center text-gray-500">
                                            {depense.dateValidationRT
                                              ? new Date(depense.dateValidationRT).toLocaleDateString('fr-FR', {
                                                  day: '2-digit',
                                                  month: 'short',
                                                  year: 'numeric'
                                                })
                                              : depense.created
                                                ? new Date(depense.created).toLocaleDateString('fr-FR')
                                                : "-"}
                                            {/* Date de modification si présente */}
                                            {depense.dateModification && (
                                              <div className="text-[10px] text-red-500 font-semibold">
                                                Modifié : {new Date(depense.dateModification).toLocaleDateString('fr-FR')}
                                              </div>
                                            )}
                                          </td>
                                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                                            {depense.fournisseur || "-"}
                                          </td>
                                          <td className="px-4 py-3 whitespace-nowrap text-sm text-center">
                                            <div className="flex items-center justify-center space-x-2">
                                              <button
                                                onClick={() => {
                                                  handleValider(depense);
                                                  if (hasNewUpdate) {
                                                    markRTAsViewed(depense.id);
                                                  }
                                                }}
                                                className="inline-flex items-center justify-center p-2 bg-green-100 text-green-700 rounded-full hover:bg-green-200 transition-colors duration-200"
                                                title="Valider cette dépense"
                                              >
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                                </svg>
                                              </button>
                                              <button
                                                onClick={() => {
                                                  handleMettreEnAttente(depense);
                                                  if (hasNewUpdate) {
                                                    markRTAsViewed(depense.id);
                                                  }
                                                }}
                                                className="inline-flex items-center justify-center p-2 bg-yellow-100 text-yellow-700 rounded-full hover:bg-yellow-200 transition-colors duration-200"
                                                title="Mettre cette dépense en attente"
                                              >
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
                                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l2 2" />
                                                </svg>
                                              </button>
                                            </div>
                                          </td>
                                          <td className="px-4 py-3 whitespace-nowrap text-sm text-center">
                                            {depense.justificatif ? (
                                              <button
                                                className="text-blue-700 underline"
                                                onClick={() => {
                                                  setJustificatifUrl(getJustificatifUrl(depense));
                                                  setShowJustificatifModal(true);
                                                }}
                                              >
                                                Voir
                                              </button>
                                            ) : (
                                              "-"
                                            )}
                                          </td>
                                        </tr>
                                      )
                                    })
                                  )}
                                </>
                              </React.Fragment>
                            ))}

                          </tbody>
                        </table>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}

          

          {/* ===== AFFICHAGE DES IMMOBILISATIONS ===== */}
          {activeView === 'immobilisations' && (
            <div className="animate-fade-in">
              {showImmoHistory ? (
                <div className="bg-white rounded-xl shadow p-6">
                  <EtatImmoStructure onClose={() => setShowImmoHistory(false)} />
                </div>
              ) : (
                <>
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">
                      Gestion des Immobilisations
                    </h2>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={async () => {
                          setLoadingImmobilisations(true);
                          try {
                            const data = await pb.collection('immobilisation').getFullList({
                              filter: "statut = 'en attente'",
                              sort: '-created',
                            });
                            setImmobilisations(data);
                            setNotification({ type: 'success', text: 'Demandes d\'immobilisations actualisées !' });
                          } catch (error) {
                            setNotification({ type: 'error', text: "Erreur lors de l'actualisation des immobilisations." });
                          }
                          setLoadingImmobilisations(false);
                        }}
                        className="bg-purple-100 text-purple-800 px-3 py-2 rounded shadow hover:bg-purple-200 font-semibold flex items-center gap-1 text-sm"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                        Actualiser
                      </button>
                      <button
                        onClick={() => setShowImmoHistory(true)}
                        className="bg-purple-100 text-purple-800 px-4 py-2 rounded shadow hover:bg-purple-200 font-semibold flex items-center gap-2"
                      >
                        <FontAwesomeIcon icon={faHistory} />
                        Historique des immobilisations
                      </button>
                    </div>
                  </div>
                  {loadingImmobilisations ? (
                    <div className="flex justify-center items-center h-40">
                      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-700"></div>
                    </div>
                  ) : immobilisations.length === 0 ? (
                    <div className="text-center py-12 text-gray-500">
                      <p>Aucune demande d'immobilisation à traiter</p>
                    </div>
                  ) : (
                    <div className="overflow-x-auto bg-white rounded-xl shadow border">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead>
                          <tr>
                            <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rubrique</th>
                            <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sous-rubrique</th>
                            <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                            <th className="px-6 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Montant</th>
                            <th className="px-6 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                            <th className="px-6 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {immobilisations.map((immo) => (
                            <tr key={immo.id} className="hover:bg-gray-50 transition-colors duration-150">
                              <td className="px-6 py-4 whitespace-nowrap"><div className="text-sm font-medium text-gray-900">{immo.rubrique || "-"}</div></td>
                              <td className="px-6 py-4 whitespace-nowrap"><div className="text-sm text-gray-700">{immo.sousRubrique || "-"}</div></td>
                              <td className="px-6 py-4">
                                <button
                                  onClick={() => handleDescriptionClick(immo.description)}
                                  className="text-blue-600 hover:underline text-sm"
                                >
                                  Lire
                                </button>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-right"><div className="text-sm font-semibold text-gray-900"><span className="font-mono">{Number(immo.montant).toLocaleString()} FCFA</span></div></td>
                              <td className="px-6 py-4 whitespace-nowrap text-center"><div className="text-sm text-gray-500">{new Date(immo.dateCreation).toLocaleDateString()}</div></td>
                              <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                <div className="flex items-center justify-center gap-2">
                                  <button onClick={() => handleValiderImmobilisation(immo)} className="px-3 py-1 bg-green-100 text-green-700 rounded hover:bg-green-200 font-semibold text-xs">Valider</button>
                                  <button onClick={() => handleMettreEnAttenteImmobilisation(immo)} className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded hover:bg-yellow-200 font-semibold text-xs">Mettre en attente</button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </main>
      </div>

      {activeView === "notifications" && <NotificationsView />}

          {/* Affichage du tableau des charges de structure */}
          {activeView === 'chargesStructure' && (
            <main className="flex-1 overflow-auto p-6 pl-60 pt-20 animate-fade-in">
              {/* Affichage de l'historique des charges */}
              {showChargesHistory ? (
                <div className="bg-white rounded-xl shadow p-6">
                  <EtatChargesStructure onClose={() => setShowChargesHistory(false)} />
                </div>
              ) : (
                <>
                  <div className="flex justify-between items-center mb-4">
                    <div className="flex border-b">
                      <button
                        onClick={() => setChargesSubView('aTraiter')}
                        className={`px-4 py-2 text-sm font-semibold transition-colors duration-200 ${chargesSubView === 'aTraiter' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500 hover:text-blue-600'}`}
                      >
                        Demandes à Traiter
                      </button>
                    </div>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={async () => {
                          // Trigger refresh for charges
                          setLoadingChargesStructure(true);
                          try {
                            // Fetch charges from main collection
                            const nouvellesCharges = await pb.collection('chargesStructure').getFullList({
                              filter: "statut = 'en attente'",
                              sort: '-created',
                            });

                            // Fetch modified/hold charges from chargemea
                            const chargesModifiees = await pb.collection('chargemea').getFullList({
                              filter: '(statut = "en attente" || statut = "modifiée") && meaPar != "Controleur de Gestion" && meaPar != "DG"',
                              sort: '-created',
                            });

                            // Combine both lists
                            setChargesStructure([...nouvellesCharges, ...chargesModifiees]);
                            setNotification({ type: 'success', text: 'Demandes de charges actualisées !' });
                          } catch (error) {
                            console.error("Erreur lors de l'actualisation des charges:", error);
                            setNotification({ type: 'error', text: "Erreur lors de l'actualisation des charges." });
                          }
                          setLoadingChargesStructure(false);
                        }}
                        className="bg-blue-100 text-blue-800 px-3 py-2 rounded shadow hover:bg-blue-200 font-semibold flex items-center gap-1 text-sm"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                        Actualiser
                      </button>
                      <button
                        onClick={() => setShowChargesHistory(true)}
                        className="bg-blue-100 text-blue-800 px-4 py-2 rounded shadow hover:bg-blue-200 font-semibold flex items-center gap-2"
                      >
                        <FontAwesomeIcon icon={faHistory} />
                        Historique des charges
                      </button>
                    </div>
                  </div>

              {chargesSubView === 'aTraiter' && (<>
                {loadingChargesStructure ? (
                  <div className="flex justify-center items-center h-40">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-700"></div>
                  </div>
                ) : chargesStructure.length === 0 ? (
                  <div className="text-center py-12 text-gray-500">
                    <p>Aucune charge de structure à traiter</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto bg-white rounded-xl shadow border">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead>
                        <tr>
                          <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rubrique</th>
                          <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                          <th className="px-6 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Montant</th>
                          <th className="px-6 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Statut</th>
                          <th className="px-6 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {chargesStructure.map((charge) => (
                          <tr key={charge.id} className="hover:bg-gray-50 transition-colors duration-150">
                            <td className="px-6 py-4">
                              <div className="text-sm font-medium text-gray-900">
                                {charge.rubrique || "-"}
                              </div>
                            </td>
                            <td className="px-6 py-4">
                              <div className="text-sm text-gray-700 line-clamp-2">
                                {charge.description}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right">
                              <div className="text-sm font-semibold text-gray-900">
                                <span className="font-mono">{Number(charge.montant).toLocaleString()} FCFA</span>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-center">
                              <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                  charge.statut === 'en attente' ? 'bg-yellow-100 text-yellow-800' :
                                  charge.statut === 'modifiée' ? 'bg-blue-100 text-blue-800' :
                                  charge.statut === 'validé' ? 'bg-green-100 text-green-800' :
                                  'bg-red-100 text-red-800'
                                }`}>
                                {charge.statut}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                              <div className="flex items-center justify-center gap-2">
                                <button
                                  onClick={() => handleValiderChargeStructure(charge)}
                                  className="px-3 py-1 bg-green-100 text-green-700 rounded hover:bg-green-200 font-semibold text-xs"
                                >
                                  Valider
                                </button>
                                <button
                                  onClick={() => handleMettreEnAttenteCharge(charge)}
                                  className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded hover:bg-yellow-200 font-semibold text-xs"
                                >
                                  Mettre en attente
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>)}

              {chargesSubView === 'enAttente' && (
                <div className="animate-fade-in p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">
                Charges Mises en Attente par Vous
              </h2>
              {loadingChargesEnAttenteCG ? (
                <div className="flex justify-center items-center h-40">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-700"></div>
                </div>
              ) : chargesEnAttenteCG.length === 0 ? (
                <div className="text-center py-12 bg-gray-50 rounded-lg">
                  <span className="text-orange-400 text-4xl mb-3">📝</span>
                  <p className="text-gray-600">Vous n'avez aucune charge en attente.</p>
                </div>
              ) : (
                Object.entries(groupByProjet(chargesEnAttenteCG)).map(([projetNom, charges]) => (
                  <div key={projetNom} className="mb-8">
                    <div className="cursor-pointer bg-gradient-to-br from-orange-50 to-white rounded-xl shadow-lg p-5 border-l-8 border-orange-500 mb-4">
                      <div className="flex items-center gap-3">
<span className="font-bold text-lg text-orange-900">{projetNom === 'Charges' ? 'Immo' : projetNom}</span>
                        <span className="ml-auto bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-xs font-bold">
                          {charges.length} charge{charges.length > 1 ? "s" : ""}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {charges.map((charge) => {
                        const updateKey = `chargeMEA-${charge.id}`;
                        // Afficher le badge uniquement si la modif vient du charge de structure
                        const showBadge = charge.hasNewUpdate && !viewedChargeUpdates.includes(updateKey) && charge.meaPar !== "Controleur de Gestion";
                        const updateCount = charge.updateCount || 0;
                        // Ajoute cette ligne :
                        const hasNewUpdate = charge.hasNewUpdate && !viewedChargeUpdates.includes(updateKey) && charge.meaPar !== "Controleur de Gestion";

                        return (
                          <div key={charge.id} className="bg-white rounded-lg shadow border-l-4 border-orange-500 p-4 flex flex-col justify-between relative">
                            <div className="flex items-center gap-2 mb-1">
                              <span className="text-yellow-500 text-lg">⏸️</span>
                              <span className="font-semibold text-xs text-yellow-700">Mise en attente</span>
                              {/* Badge MODIFIÉ collé au titre */}
                              {showBadge && updateCount > 0 && (
                                <span className="ml-2 bg-red-500 text-white rounded-full px-2 py-0.5 text-xs font-bold shadow-lg animate-pulse">
                                  {updateCount}
                                </span>
                              )}
                              {hasNewUpdate && (
                                <span className="bg-red-100 text-red-600 px-1 py-0.5 rounded text-[10px] font-bold ml-2">
                                  NOUVEAU
                                </span>
                              )}
                            </div>
                            <div className="mb-3 space-y-1.5 text-xs">
                              <div className="text-gray-600">
                                <span className="font-semibold text-orange-700">Motif : </span>
                                <span className="break-words">{charge.motif || "-"}</span>
                              </div>
                              <div className="text-gray-600">
                                <span className="font-semibold text-orange-700">Description : </span>
                                <span className="break-words">{charge.description || "-"}</span>
                              </div>
                              <div className="font-semibold text-gray-800">
                                <span className="font-semibold text-orange-700">Montant : </span>
                                {Number(charge.montant).toLocaleString()} FCFA
                              </div>
                               <div className="text-gray-500 italic">
                                {charge.dateModification 
                                  ? `Modifié le: ${new Date(charge.dateModification).toLocaleString()}`
                                  : `Mis en attente le: ${new Date(charge.datemea).toLocaleString()}`
                                }
                              </div>
                            </div>
                            <hr className="my-2 border-gray-200" />
                             <div className="flex justify-end mt-2 space-x-2">
                            <button
                              className="px-3 py-1 bg-green-100 text-green-700 rounded hover:bg-green-200 font-semibold text-xs"
                              onClick={async () => {
                                // VALIDER : stocker dans chargeValideesCG
                                await pb.collection('chargesValideesCG').create({
                                  rubrique: charge.rubrique,
                                  sousRubrique: charge.sousRubrique || '',
                                  description: charge.description,
                                  montant: charge.montant,
                                  statut: 'validé',
                                  dateValidationCG: new Date().toISOString(),
                                  createdBy: charge.createdBy,
                                });
                                // Optionnel : retirer la charge de la liste locale
                                setChargesEnAttenteCG(prev => prev.filter(c => c.id !== charge.id));
                                setNotification({ type: 'success', text: 'Charge validée avec succès !' });
                              }}
                            >
                              Valider
                            </button>
                            <button
                              className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded hover:bg-yellow-200 font-semibold text-xs"
                              onClick={() => {
                                setChargeToHold(charge);
                                setShowChargeAttenteModal(true);
                              }}
                            >
                              En attente
                            </button>
                          </div>
                        </div>
                      )})}
                    </div>
                  </div>
                ))
              )}
            </div>
              )}
            </>
          )}
        </main>
      )}


      {/* ===== MODALES ===== */}

      {/* Modale de description et détails pour les dépenses MEA */}
      {showDescriptionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          {selectedNotif ? (
            <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full mx-4 border-4 border-yellow-200 animate-fade-in flex flex-col max-h-[90vh]">
              <div className="px-6 py-4 border-b border-yellow-100 flex justify-between items-center rounded-t-2xl bg-gradient-to-r from-yellow-50 to-yellow-100">
                <h3 className="text-lg font-bold text-yellow-800 flex items-center gap-2">
                  <span className="text-yellow-500">⏸️</span>
                  Détails de la dépense mise en attente
                </h3>
                <button
                  onClick={() => {
                    setShowDescriptionModal(false);
                    setSelectedNotif(null);
                  }}
                  className="text-gray-400 hover:text-gray-600 transition-colors text-2xl"
                >
                  ✕
                </button>
              </div>
              <div className="px-6 py-6 bg-gradient-to-br from-yellow-50 to-white flex-1 overflow-y-auto">
                <div className="space-y-4">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-yellow-700">Rubrique :</span>
                    <span>
                      {selectedNotif.rubrique
                        || (Array.isArray(selectedNotif.rubriques) && selectedNotif.rubriques[0]?.rubrique)
                        || (typeof selectedNotif.rubriques === "object" && selectedNotif.rubriques?.rubrique)
                        || selectedNotif.rubriques?.nom
                        || "-"
                      }
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-yellow-700">Sous-rubrique :</span>
                    <span>
                      {selectedNotif.sousRubrique
                        || (Array.isArray(selectedNotif.rubriques) && selectedNotif.rubriques[0]?.sousRubrique)
                        || (typeof selectedNotif.rubriques === "object" && selectedNotif.rubriques?.sousRubrique)
                        || "-"
                      }
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-yellow-700">Montant :</span>
                    <span className="font-mono text-yellow-900">{Number(selectedNotif.montant).toLocaleString()} FCFA</span>
                  </div>
                  <div>
                    <span className="font-semibold text-yellow-700">Description :</span>
                    <div className="mt-1 bg-yellow-50 rounded p-2 text-gray-700">{selectedNotif.description || "-"}</div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-yellow-700">Date :</span>
                    <span>
                      {selectedNotif.datemea
                        ? new Date(selectedNotif.datemea).toLocaleString()
                        : selectedNotif.created
                          ? new Date(selectedNotif.created).toLocaleString()
                          : "-"}
                    </span>
                  </div>
                  {selectedNotif.fournisseur && (
                    <div className="flex items-center gap-2">
                      <span className="font-semibold text-yellow-700">Fournisseur :</span>
                      <span>{selectedNotif.fournisseur}</span>
                    </div>
                  )}
                  <div>
                    <span className="font-semibold text-yellow-700">Mise en attente par :</span>
                    <span className="font-bold">{selectedNotif.meaPar || "-"}</span>
                  </div>
                </div>
              </div>
              <div className="px-6 py-4 bg-yellow-50 flex justify-end rounded-b-2xl">
                <button
                  onClick={() => {
                    setShowDescriptionModal(false);
                    setSelectedNotif(null);
                  }}
                  className="px-5 py-2 bg-yellow-200 text-yellow-900 rounded-lg font-semibold hover:bg-yellow-300 transition-colors shadow"
                >
                  Fermer
                </button>
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 overflow-hidden">
              <div className="px-6 py-4 bg-gray-50 flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900">Description détaillée</h3>
                <button
                  onClick={() => setShowDescriptionModal(false)}
                  className="text-gray-400 hover:text-gray-600 text-2xl"
                >
                  ✕
                </button>
              </div>
              <div className="flex-1 p-4 overflow-auto" style={{ minHeight: 400, maxHeight: '70vh' }}>
                <p className="text-gray-600 whitespace-pre-wrap">{selectedDescription}</p>
              </div>
              <div className="px-6 py-4 bg-gray-50 flex justify-end">
                <button
                  onClick={() => setShowDescriptionModal(false)}
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
                >
                  Fermer
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Modale d'action MEA */}
      {showMEAActionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden">
            <div className="px-6 py-4 bg-gray-50 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900">
                {actionType === 'validate' ? 'Confirmation de validation' : 'Nouveau motif de mise en attente'}
              </h3>
              <button
                onClick={() => setShowMEAActionModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                ✕
              </button>
            </div>
            <div className="px-6 py-6">
              {actionType === 'validate' ? (
                <p className="text-gray-700">
                  Êtes-vous sûr de vouloir valider cette dépense ? Elle sera transférée vers les dépenses validées CG.
                </p>
              ) : (
                <div>
                  <p className="text-gray-700 mb-3">
                    Veuillez saisir le nouveau motif de mise en attente :
                  </p>
                  <textarea
                    ref={motifMEAActionRef}
                    className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-yellow-200"
                    rows={4}
                    placeholder="Saisissez le nouveau motif ici..."
                    defaultValue={selectedMEADepense?.motif || ''}
                  />
                </div>
              )}
            </div>
            <div className="px-6 py-4 bg-gray-50 flex justify-end gap-2">
              <button
                onClick={() => setShowMEAActionModal(false)}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Annuler
              </button>
              <button
                onClick={confirmMEAAction}
                className={`px-4 py-2 rounded text-white ${
                  actionType === 'validate' 
                    ? 'bg-green-600 hover:bg-green-700' 
                    : 'bg-yellow-600 hover:bg-yellow-700'
                }`}
              >
                {actionType === 'validate' ? 'Valider' : 'Mettre à jour'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modale de mise en attente pour les dépenses du tableau de bord */}
      {showAttenteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
            <h2 className="text-lg font-bold mb-4 text-yellow-700">Motif de la mise en attente</h2>
            <textarea
              className="w-full border border-gray-300 rounded p-2 mb-4"
              rows={4}
              placeholder="Saisissez le motif ici..."
              value={motifAttente}
              onChange={e => setMotifAttente(e.target.value)}
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => {
                  setShowAttenteModal(false);
                  setMotifAttente('');
                  setDepenseToAttente(null);
                }}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Annuler
              </button>
              <button
                onClick={confirmMettreEnAttente}
                className="px-4 py-2 bg-yellow-600 text-white rounded hover:bg-yellow-700"
              >
                Mettre en attente
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modale pour le motif de mise en attente des charges */}
      {showChargeAttenteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
            <h2 className="text-lg font-bold mb-4 text-yellow-700">Motif de la mise en attente</h2>
            <textarea
              className="w-full border border-gray-300 rounded p-2 mb-4"
              rows={4}
              placeholder="Saisissez le motif de la mise en attente ici..."
              value={motifAttenteCharge}
              onChange={e => setMotifAttenteCharge(e.target.value)}
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => {
                  setShowChargeAttenteModal(false);
                  setMotifAttenteCharge('');
                  setChargeToHold(null);
                }}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Annuler
              </button>
              <button
                onClick={confirmMettreEnAttenteCharge}
                className="px-4 py-2 bg-yellow-600 text-white rounded hover:bg-yellow-700"
              >
                Mettre en attente
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modale pour le motif de mise en attente des immobilisations */}
      {showImmoAttenteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
            <h2 className="text-lg font-bold mb-4 text-yellow-700">Motif de la mise en attente (Immobilisation)</h2>
            <textarea
              className="w-full border border-gray-300 rounded p-2 mb-4"
              rows={4}
              placeholder="Saisissez le motif ici..."
              value={motifAttenteImmo}
              onChange={e => setMotifAttenteImmo(e.target.value)}
            />
            <div className="flex justify-end gap-2">
              <button
                onClick={() => {
                  setShowImmoAttenteModal(false);
                  setMotifAttenteImmo('');
                  setImmoToHold(null);
                }}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Annuler
              </button>
              <button
                onClick={confirmMettreEnAttenteImmobilisation}
                className="px-4 py-2 bg-yellow-600 text-white rounded hover:bg-yellow-700"
              >
                Mettre en attente
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modale justificatif */}
      {showJustificatifModal && justificatifUrl && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden">
            <div className="px-6 py-4 bg-blue-50 flex items-center justify-between border-b">
              <h3 className="text-lg font-semibold text-blue-900">Justificatif de la dépense</h3>
              <button
                onClick={() => {
                  setShowJustificatifModal(false);
                  setJustificatifUrl(null);
                }}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                ✕
              </button>
            </div>
            <div className="px-6 py-6 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 140px)' }}>
              {justificatifUrl.toLowerCase().endsWith('.pdf') ? (
                <iframe
                  src={justificatifUrl}
                  className="w-full h-96 border rounded"
                  title="Justificatif PDF"
                />
              ) : (
                <img
                  src={justificatifUrl}
                  alt="Justificatif"
                  className="max-w-full h-auto rounded shadow"
                />
              )}
            </div>
            <div className="px-6 py-4 bg-gray-50 flex justify-between items-center border-t">
              <a
                href={justificatifUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
              >
                Ouvrir dans un nouvel onglet
              </a>
              <button
                onClick={() => {
                  setShowJustificatifModal(false);
                  setJustificatifUrl(null);
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modale de déconnexion */}
      {showLogoutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-sm animate-fade-in">
            <h2 className="text-lg font-semibold mb-4 text-center text-gray-800">Confirmation</h2>
            <p className="text-gray-700 mb-6 text-center">Êtes-vous sûr de vouloir vous déconnecter ?</p>
            <div className="flex justify-around">
              <button
                onClick={cancelLogout}
                className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
              >
                Non
              </button>
              <button
                onClick={confirmLogout}
                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                Oui
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Notification Box */}
      <NotificationBox />
    </div>
  );
}; export default ComptableDashboard  ;
